// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.app-main-header .search-bar {
  display: none !important;
}

div.form-input-tooltip {
  position: relative;
  padding-inline-end: 30px;
}

div.form-input-tooltip > i {
  position: absolute;
  top: 2px;
  inset-inline-end: 0;
}

div.tooltip {
  z-index: 2000;
}

.user-info-menu a.dropdown-item.text-muted.active {
  background: initial;
}

.sidebar-header .mini-logo > img {
  height: 32px;
}

.app-main-header .logo-img,
.sidebar-header .logo-img {
  height: 48px;
}

.jr-card-without-border .jr-card {
  border: none;
}

.json-schema-view .jr-card {
  border-top-left-radius: 0;
  padding: 3px;
  margin: 0px;
}

.json-schema-view .jr-entry-header {
  padding: 0px;
  margin: 0px;
}

table.json-schema-view-property-info td {
  text-align: left;
}

.json-data-view ul {
  list-style-type: none;
}

.json-data-view li {
  margin-top: 2px;
  margin-bottom: 2px;
}

.json-data-view > ul {
  padding-inline-start: 0;
}

.json-data-view li > ul {
  padding-inline-start: 15px;
}

.json-data-view .badge {
  margin-inline-end: 3px !important;
}

.add-new-version-button {
  margin: 0px !important;
  margin-inline-start: 3px !important;
  padding: 3px !important;
  text-transform: initial !important;
}

.service-template-text {
  min-height: 400px;
}

.rdtOpen .rdtPicker {
  width: fit-content;
}
.rdtOpen .rdtPicker .has-day-value {
  background-color: #eeeff2;
}
.rdtOpen .rdtPicker .selected-range-day {
  background-color: #428bca;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}

.fade .modal-dialog.layer {
  inset-inline-end: -100%;
  transition-property: inset-inline-end, inset-inline-start;
}
.fade .modal-dialog.layer.modal-align-left {
  inset-inline-end: initial;
  inset-inline-start: -100%;
}
.fade.show .modal-dialog.layer {
  inset-inline-end: 0%;
}
.fade.show .modal-dialog.layer.modal-align-left {
  inset-inline-end: initial;
  inset-inline-start: 0%;
}

.modal-open .theme-option {
  display: none;
}

table.table-scroll {
  position: relative;
  width: 100%;
  z-index: 1;
  margin: auto;
  overflow: auto;
  display: block;
}

table.table-scroll > tbody > tr > td {
  z-index: 1;
}

table.table-scroll > thead > tr > th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
}

table.table-scroll > tfoot,
table.table-scroll > tfoot > tr > th,
table.table-scroll > tfoot > tr > td {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 0;
}

.sheet-viewer .sheet-name-list {
  border-top: 1px solid;
}

.sheet-viewer .sheet-name-list > span + span {
  margin-inline-start: 10px;
}

.sheet-viewer .sheet-name-list > span.selected {
  font-weight: bold;
}

/* button */
.btn.btn-outline-primary:hover {
  color: white;
}

button {
  -webkit-appearance: none;
  background-color: transparent;
}

.btn.btn-primary,
.btn.btn-secondary,
.btn.btn-default,
.btn.btn-dark,
.btn.btn-success,
.btn.btn-danger,
.btn.btn-warning,
.btn.btn-outline-primary,
.btn.btn-outline-secondary,
.btn.btn-outline-default,
.btn.btn-outline-dark,
.btn.btn-outline-success,
.btn.btn-outline-danger,
.btn.btn-outline-warning {
  border-radius: 6px;
  padding: 3px 16px;
  line-height: 20px;
}
.btn.btn-primary span,
.btn.btn-secondary span,
.btn.btn-default span,
.btn.btn-dark span,
.btn.btn-success span,
.btn.btn-danger span,
.btn.btn-warning span,
.btn.btn-outline-primary span,
.btn.btn-outline-secondary span,
.btn.btn-outline-default span,
.btn.btn-outline-dark span,
.btn.btn-outline-success span,
.btn.btn-outline-danger span,
.btn.btn-outline-warning span {
  font-size: 12px;
}

.btn.btn-rounded {
  border-radius: 15px;
  padding: 4px 16px;
  border: none;
  line-height: 22px;
}

.btn.btn-dark {
  background-color: rgba(0, 0, 0, 0.39);
  border-color: rgba(0, 0, 0, 0.39);
}

.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled):hover,
.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
  background-color: rgb(230, 230, 230);
}

/* React Table */
.ReactTable {
  border: none !important;
  border-top: solid 1px #ccc !important;
}

.rt-table {
  overflow-x: hidden !important;
}
.rt-table > .rt-thead {
  background: #f4f4f4;
}
.rt-table > .rt-thead > .tr > .th .column-filter > input {
  width: 100%;
}

.ReactTable.limited-height .rt-table {
  max-height: 65vh;
}

.ReactTable .rt-table.all-hidden .rt-thead .rt-tr .rt-th.rthfc-th-fixed-right,
.ReactTable .rt-table.all-hidden .rt-tbody .rt-tr-group .rt-tr .rt-td.rthfc-td-fixed-right {
  background-color: transparent;
  border-inline-start: none;
}

.ReactTable .rt-table.all-hidden .rt-tfoot .rt-tr .rt-td.rthfc-td-fixed-right {
  display: none;
}

.ReactTable .rt-table.all-hidden .rt-thead .rt-tr .rt-th.rthfc-th-fixed-right,
.ReactTable .rt-table.all-hidden .rt-tbody .rt-tr-group .rt-tr .rt-td.rthfc-td-fixed-right * {
  visibility: hidden;
}

.ReactTable .rt-tbody .rt-th,
.ReactTable .rt-tbody .rt-td {
  border-inline-start: solid 1px rgba(0, 0, 0, 0.05);
  border-inline-end: solid 1px rgba(0, 0, 0, 0.02);
}

.ReactTable .rt-td:not(.link-cell) {
  cursor: pointer;
}

.ReactTable .btn-link {
  padding: 0;
  margin: 0;
}

.ReactTable .btn-link + .btn-link,
.ReactTable .btn-link + div .btn-link {
  margin-inline-start: 4px;
}

.ReactTable.rthfc.-sp .rthfc-th-fixed-right, .rthfc.-sp .rthfc-td-fixed-right {
  text-align: center !important;
}

.ReactTable.rthfc .-headerGroups {
  border: none;
}

.ReactTable.rthfc .-headerGroups .rt-th {
  background-color: #D4D9DF;
  max-width: none !important;
}

.ReactTable.rthfc .-headerGroups .rt-th.block-cell {
  background-color: #D4D9DF;
  border-inline-start: 1px solid #ccc;
  border-inline-end: 1px solid #ccc;
}

.ReactTable.rthfc .-headerGroups .rt-th:empty {
  padding: 0;
}

.ReactTable .rt-thead.-header {
  box-shadow: none !important;
}

.ReactTable .rt-thead.-header[style*="top: 1px"] {
  top: 0 !important;
  margin-top: -1px !important;
}

.rt-th:not(.block-cell) + .block-cell,
.rt-td:not(.block-cell) + .block-cell,
.link-cell + .rt-th:not(.link-cell),
.link-cell + .rt-td:not(.link-cell) {
  border-inline-start: 1px solid #ccc;
}

.link-cell {
  overflow-x: initial !important;
}

.rt-th.the-last ~ .rt-th,
.rt-td.the-last ~ .rt-td {
  border-inline-start: solid 1px rgba(0, 0, 0, 0.05);
}

.block-cell.editgrid-cell + .rt-th,
.block-cell.editgrid-cell + .rt-td,
.rt-th:not(.field-block) + .rt-th.field-block.block-cell,
.rt-td:not(.field-block) + .rt-td.field-block.block-cell,
.rt-th.the-last + .rt-th,
.rt-td.the-last + .rt-td,
.rt-th.the-first.block-cell,
.rt-td.the-first.block-cell {
  border-inline-start: 1px solid #ccc;
}

.rt-th.field-block + .rt-th.field-block,
.rt-td.field-block + .rt-td.field-block {
  border-inline-start: solid 1px rgba(0, 0, 0, 0.05);
}

.ReactTable.rthfc .-header .rt-th {
  background-color: #≈;
  font-weight: 700;
  text-align: left;
  font-size: 12px;
}

.newtable .ReactTable .-pagination {
  padding: 0;
  font-size: 10px;
}

.newtable .ReactTable .-pagination .-btn {
  background: transparent;
}

.newtable .ReactTable .-pagination .-pageInfo {
  margin: 0px 10px;
}

.newtable .ReactTable .-pagination .-pageJump input {
  width: 42px;
  text-align: center;
  padding: 0px 7px;
}

.newtable .ReactTable .-pagination .-pageSizeOptions {
  margin: 0px 10px;
}

.newtable .ReactTable .rt-thead .rt-th.-sort-asc, .ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 rgba(24, 90, 151, 0.6);
}

.newtable .ReactTable .rt-thead .rt-th.-sort-desc, .ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 rgba(24, 90, 151, 0.6);
}

.newtable .ReactTable.rthfc .-filters .rt-th.rthfc-th-fixed-left-last,
.newtable .ReactTable.rthfc .rt-th.rthfc-th-fixed-left-last,
.newtable .ReactTable.rthfc .rt-td.rthfc-td-fixed-left-last {
  border-inline-end: 1px solid rgba(0, 0, 0, 0.02);
  border-inline-start: 1px solid rgba(0, 0, 0, 0.05);
}

.newtable .ReactTable .last-updated {
  white-space: nowrap;
  text-align: center;
  width: 142px !important;
  max-width: 142px !important;
}

.newtable .nav-tabs {
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
  padding-inline-start: 12px;
  padding-inline-end: 12px;
  padding-top: 8px;
  background-color: #99BBCD;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
  z-index: 2;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.newtable .nav-tabs .nav-pages {
  gap: 2rem;
  flex-grow: 1000;
}
.newtable .nav-tabs .nav-pages .nav-item {
  margin-inline-end: 0 !important;
}
.newtable .nav-tabs :where(.add-search, .nav-tools) {
  display: flex;
  gap: 1rem;
}
.newtable .nav-tabs .nav-tools {
  justify-content: space-between;
  flex-grow: 1;
}

.newtable .tab-content {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
  z-index: 3;
  background: #f4f4f4;
}

.newtable .nav-link {
  padding: 0.5rem 1.5rem !important;
  font-weight: 700;
  margin-inline-end: 4px;
}

.newtable .nav-link:not(.active) {
  color: white;
  transition: all 0.2s;
}

.newtable .nav-link:not(.active):hover {
  color: black;
  border: 1px solid white;
  background: white;
  transition: all 0.2s;
}

.newtable .nav-item > .dropdown > button {
  margin: 4px;
}

.newtable .filters-row {
  padding: 0px 0px 1rem;
}

.newtable .filters-row .dropdown,
.audit-log-table-toolbar .dropdown  {
  flex: 1;
}

.overflow-y-visble {
  overflow-y: visible !important;
}

.btn-icon {
  width: 26px;
  height: 26px;
  padding: 0 !important;
  /* line-height: 1; */
  line-height: 13px;
  border-radius: 13px;
  text-align: center;
}

.newtable .search--table,
.audit-log-table-toolbar .search--table {
  padding: 2px 0 2px 8px;
  transition: all 0.2s;
  border-bottom: solid 1px #f4f4f4;
  color: white;
  display: inline-flex;
  height: var(--custom-height, 26px);
  width: auto;
  align-items: center;
}

.newtable .search--table:hover,
.newtable .search--table:focus,
.audit-log-table-toolbar .search--table:hover,
.audit-log-table-toolbar .search--table:focus,
.newtable .search--table:focus-within,
.audit-log-table-toolbar .search--table:focus-within {
  transition: all 0.2s;
  opacity: 1;
}

.newtable .search--table input,
.audit-log-table-toolbar .search--table input {
  border: none;
  display: flex;
  background: transparent;
  width: 100%;
}

.newtable .search--table i,
.audit-log-table-toolbar .search--table i {
  display: inline-flex;
}

.newtable .search--table input:focus,
.newtable .search--table input:active,
.audit-log-table-toolbar .search--table input:active,
.audit-log-table-toolbar .search--table input:focus {
  outline: none;
}

.nav-item + .search--table.ml-3 {
  margin-inline-start: auto !important;
}

.hidden {
  display: none !important;
}

.col-status-icon {
  margin-inline-end: 4px;
}

.col-status-icon.zmdi-circle {
  color: green;
}

.col-status-icon.zmdi-circle-o {
  color: #F4F4F4;
}

.json-data-view button {
  margin: 0;
  display: flex;
}

.json-data-view .json-data-view-array > li + li {
  border-top: 1px solid #dee2e6;
}

.modal-sizable {
  max-width: 100% !important;
}
.modal-sizable .modal-content > div {
  display: flex;
}
.modal-sizable .modal-content .resizer {
  cursor: col-resize;
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: -12px;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  background: #efefef;
  display: block;
  padding: 0 3px;
  line-height: 100vh;
  z-index: 1234;
  opacity: 0;
}
.modal-sizable .modal-content:hover .resizer {
  opacity: 1;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.modal-sizable.modal-align-left .resizer {
  inset-inline-start: auto;
  inset-inline-end: -12px;
}

table.json-data-view-object-item td:nth-child(2),
table.json-data-view-array td:nth-child(2) {
  padding-inline-end: 0;
}

table.json-data-view-object-item > tr:nth-child(1) > td,
table.json-data-view-array > tr:nth-child(1) > td {
  border-top: none;
}

.item-fieldname-cell {
  width: 25%;
  vertical-align: top;
}

.history-icon {
  color: #91adf0;
  font-size: 14px;
}

.field-history-icon-container:not(:last-child) {
  margin-right: 0.5rem;
}
.field-history-icon-container:last-child {
  display: flex;
  align-self: self-start;
  padding: 10px;
  border-radius: 4px;
}
.field-history-icon-container:last-child:hover {
  background-color: #ebf1f6;
}

.field-history .db-audit-field-log-list-table .rt-table {
  overflow-x: auto !important;
}
.field-history-modal .modal-content > div > div {
  min-width: initial !important;
}
.field-history-info {
  margin-bottom: 1.5rem;
}
.field-history-info .info-heading {
  font-weight: 400;
  color: #4B4B4B;
}
.field-history-info .info-value {
  font-weight: 600;
  color: #222222;
}
.field-history-info :where(th, td) + :where(th, td) {
  padding-inline-start: 16px;
}

.block-history {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.history-entries {
  display: flex;
  overflow-x: auto;
  padding-bottom: 16px;
}

.history-item {
  min-width: 150px;
  border: solid 1px #f2f2f2;
}
.history-item.selected {
  background-color: #ebf1f6;
  transition-duration: 0.15s;
}
.history-item-date {
  padding: 6px 10px;
  font-weight: 600;
}
.history-item-field .pointer {
  align-items: center;
  justify-content: space-between;
}
.history-item-field .pointer:hover {
  background-color: #f2f2f2;
}
.history-item-field.selected .pointer {
  background-color: #d2dfeb;
}
.history-item .item-field-name {
  display: flex;
  padding: 6px 10px;
  gap: 10px;
}

/*table.json-data-view-object-item td[colspan='2'] > table > tbody > tr > td,
table.json-data-view-array td[colspan='2'] > table > tbody > tr > td {
    border: none;
}*/
table.json-data-view-object-item td > .table,
table.json-data-view-array td > .table {
  background-color: transparent;
}

.json-data-view-array > tr:nth-child(odd) {
  background-color: #f4f4f4;
}

.json-data-view-array > tr:nth-child(even) {
  background-color: #efefef;
}

.import-json-button, .export-json-button {
  margin: 0 !important;
  position: absolute !important;
  top: 0 !important;
  inset-inline-end: 0 !important;
  display: inline-block !important;
  font-weight: 400 !important;
  text-align: center !important;
  white-space: nowrap !important;
  vertical-align: middle !important;
  user-select: none !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 13px !important;
  line-height: 1.2 !important;
  border-radius: 0.25rem !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  color: #99BBCD !important;
  background-color: transparent !important;
  background-image: none !important;
  border-color: #99BBCD !important;
  text-shadow: none !important;
  height: auto !important;
}

.import-json-button:hover,
.import-json-button:focus,
.import-json-button:active,
.export-json-button:hover,
.export-json-button:focus,
.export-json-button:active {
  color: #fff !important;
  background-color: #99BBCD !important;
  border-color: #99BBCD !important;
}

.export-json-button {
  inset-inline-end: 140px !important;
}

.json-schema-react-editor .close {
  float: none;
  opacity: 1;
  font-size: inherit;
}

@media screen and (min-width: 1280px) {
  .json-schema-react-editor .col-item-name {
    width: 35% !important;
  }
  .json-schema-react-editor .col-item-desc {
    width: 10% !important;
  }
}
.Resizer {
  background: #000;
  opacity: 0.2;
  z-index: 1;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-background-clip: padding;
  -webkit-background-clip: padding;
  background-clip: padding-box;
}

.Resizer:hover {
  -webkit-transition: all 2s ease;
  transition: all 2s ease;
}

.Resizer.horizontal {
  height: 11px;
  margin: -5px 0;
  border-top: 5px solid rgba(255, 255, 255, 0);
  border-bottom: 5px solid rgba(255, 255, 255, 0);
  cursor: row-resize;
  width: 100%;
}

.Resizer.horizontal:hover {
  border-top: 5px solid rgba(0, 0, 0, 0.5);
  border-bottom: 5px solid rgba(0, 0, 0, 0.5);
}

.Resizer.vertical {
  width: 11px;
  margin: 0 -5px;
  border-inline-start: 5px solid rgba(255, 255, 255, 0);
  border-inline-end: 5px solid rgba(255, 255, 255, 0);
  cursor: col-resize;
}

.Resizer.vertical:hover {
  border-inline-start: 5px solid rgba(0, 0, 0, 0.5);
  border-inline-end: 5px solid rgba(0, 0, 0, 0.5);
}

.Resizer.disabled {
  cursor: not-allowed;
}

.Resizer.disabled:hover {
  border-color: transparent;
}

.SplitPane {
  position: relative !important;
}

/* Filters row */
.filters-rows .filter-row .btn-add-row {
  opacity: 0;
  pointer-events: none;
}

.filters-rows .filter-row:last-child .btn-add-row {
  opacity: 1;
  pointer-events: initial;
}

.filters-rows .filter-row:first-child [name=gate] {
  display: none;
}

.filters-row .filter-separator {
  width: 1px;
  height: 25px;
  background: #ccc;
}

.filters-row .btn.btn-default,
.filters-row .btn.btn-outline-default:hover {
  color: black;
  background-color: #F4F4F4;
}

.filters-row .btn.btn-default.btn-secondary:not(:disabled):not(.disabled):active,
.filters-row .btn.btn-default.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn.btn-default.btn-secondary.dropdown-toggle .filters-row .btn.btn-default:hover,
.filters-row .btn.btn-default:active,
.filters-row .btn.btn-default:focus {
  outline: none;
  color: black;
  background-color: #ccc;
}

.upload-label {
  display: block;
}

.db-name input#catalog_name,
.db-name input#name {
  font-weight: bold;
  font-size: 16px;
}

.db-image img {
  max-height: 50px;
}

span.db-name,
span.db-group-name {
  font-size: 20px;
  vertical-align: middle;
  font-weight: 500;
}

span.db-code {
  vertical-align: middle;
  line-height: 21px;
  font-size: 14px !important;
}

.db-image + .db-name,
.db-image + .db-group-name {
  margin-inline-start: 15px;
}

.row-extra-props {
  background: #f4f4f4;
}

.sidebar-header .db-image + .db-name {
  display: none;
}

.schema-json-editor-content {
  position: relative;
}

.ant-modal-mask {
  z-index: 1050;
}

.ant-modal-wrap {
  z-index: 1052;
}

.ant-modal-header {
  text-align: start;
}

.ant-modal-close {
  right: initial;
  inset-inline-end: 0;
}

.ant-modal-footer {
  text-align: end;
}

.no-wrap {
  white-space: nowrap;
}

.table-scrollbar {
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  min-height: 9px;
}

.table-scrollbar > div {
  height: 1px;
}

.version-label-separator {
  display: inline-flex;
  width: 1px;
  margin-inline: 4px;
  height: 14px;
  background-color: #1b255f;
  align-self: center;
}

.version-dropdown {
  justify-content: center !important;
}

.version-selector .btn {
  text-transform: none !important;
}

.popover-body.action-permission-items {
  overflow-y: auto;
  max-height: 30vh;
}

.json-data-view-object-item .rdtPicker {
  position: initial !important;
}

.docx-viewer-container {
  overflow: auto;
}

.select-box [class*=-option] {
  white-space: break-spaces;
  line-break: anywhere;
  line-height: 1.3;
}

/* Reports */
.filters-rows-action .addReport {
  display: none !important;
}

.data-filter-table + .filters-rows-action .addReport {
  display: inline-block !important;
}

.data-filter-table .react-autosuggest__container,
.data-filter-table select,
.data-filter-table .select-box > div {
  min-height: 32px;
}
.data-filter-table .select-box > div {
  border-radius: 6px;
}
.data-filter-table .select-box > div > div:first-child {
  padding: 0 8px;
}
.data-filter-table .select-box > div > div:first-child + div div {
  padding: 4px;
}
.data-filter-table td.filter-value-column .multi-select {
  min-width: 150px;
}
.data-filter-table td.filter-value-column .multi-select .mustache {
  background-color: #C0D6A0;
}
.data-filter-table td.filter-value-column .multi-select .mustache + div {
  background-color: #C0D6A0;
}

.add-report-form-container {
  width: 500px;
}

.flex-one {
  flex: 1;
}

.form-control.rbt-input-multi {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.report-applied-filters {
  font-size: 120%;
}

.report-applied-filters .filter-field,
.report-applied-filters .filter-value {
  font-weight: 800;
  color: #125375;
}

.report-applied-filters .filter-logic {
  font-weight: 600;
  padding: 0 4px;
}

.report-detail {
  display: grid;
  height: 100%;
  grid-template-rows: min-content auto 50px;
  max-width: 100%;
  overflow-x: hidden;
  grid-gap: 10px;
}
.report-detail .filters-block {
  margin-top: 1rem;
  text-align: start;
}
.report-detail .report-general-info:empty + .filters-block {
  margin-top: 0;
}

.report-table {
  max-width: 100%;
  overflow-x: hidden;
}

.report-table .table-scrollbar {
  background-color: rgba(0, 0, 0, 0.02);
  height: 9px;
}

.report-table .table-scrollbar:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.ReactTable.mainReportTable .pagination-bottom .-pagination {
  box-shadow: none;
  border-top: none;
  display: grid;
  grid-template-columns: 40px auto 40px;
  justify-content: center;
}

.ReactTable.mainReportTable .pagination-bottom .-pagination .-pageSizeOptions,
.ReactTable.mainReportTable .pagination-bottom .-pagination .-pageInfo {
  margin: 0px 10px;
}

.ReactTable.mainReportTable {
  max-height: calc(100% - 10px);
}

.report-applied-filters-edit .data-filter-table {
  margin: 0;
  width: 100%;
}

.report-applied-filters-edit .data-filter-table .form-control {
  max-width: 100%;
  width: 100%;
  min-width: 100px;
}

.report-applied-filters-edit .data-filter-table select[name=logic].form-control,
.report-applied-filters-edit .data-filter-table select[name=gate].form-control {
  min-width: 60px;
}

.report-applied-filters-edit .data-filter-table tr:not(:last-of-type) td.filter-value-column input {
  width: 100%;
}

.report-applied-filters-edit .data-filter-table tr td:last-of-type {
  width: 60px;
  text-align: left !important;
}

.rtf-viewer-container {
  padding: 5px;
  overflow-y: auto;
}

.odf-viewer-container {
  overflow-y: auto;
  overflow-x: auto;
}

.odf-viewer-container .caret {
  opacity: 0 !important;
}

.notification-container .notification-message .message {
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.notification-container:not(.notification-container-empty) {
  bottom: 0;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  max-height: 100%;
  gap: 10px;
}
.notification-container:not(.notification-container-empty) > div:only-child:not(.notification) {
  display: contents;
}
.notification-container:not(.notification-container-empty) .notification {
  margin: 0;
  width: fit-content;
  max-width: 320px;
  padding-inline-start: 3rem;
  padding: 0px;
  padding-inline-start: 56px;
  background-color: rgba(var(--toastr-color), 0.85);
  transition-duration: 0.15s;
  border: solid 1px rgb(var(--toastr-color));
  border-radius: 6px;
  --shadow-color-rgb: var(--toastr-color);
  --shadow-opacity: .5;
  box-shadow: 0px 6px 20px rgba(var(--toastr-color), 0.5);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  min-height: 56px;
  overflow: hidden;
}
.notification-container:not(.notification-container-empty) .notification::before {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: grid;
  font-style: normal;
  place-content: center;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-family: "Font Awesome 6 Pro";
  font-weight: 700;
  position: absolute;
  inset-inline-start: 15px;
  top: 50%;
  font-size: 20px;
}
.notification-container:not(.notification-container-empty) .notification.notification-success {
  --toastr-color: 56, 159, 143;
}
.notification-container:not(.notification-container-empty) .notification.notification-success:hover {
  --toastr-color: 26, 137, 120;
}
.notification-container:not(.notification-container-empty) .notification.notification-success::before {
  content: "\\f058";
}
.notification-container:not(.notification-container-empty) .notification.notification-error {
  --toastr-color: 247, 95, 95;
}
.notification-container:not(.notification-container-empty) .notification.notification-error:hover {
  --toastr-color: 244, 47, 47;
}
.notification-container:not(.notification-container-empty) .notification.notification-error::before {
  content: "\\f057";
}
.notification-container:not(.notification-container-empty) .notification.notification-warning {
  --toastr-color: 255, 160, 118;
}
.notification-container:not(.notification-container-empty) .notification.notification-warning:hover {
  --toastr-color: 255, 124, 66;
}
.notification-container:not(.notification-container-empty) .notification.notification-warning::before {
  content: "\\f071";
}
.notification-container:not(.notification-container-empty) .notification.notification-info {
  --toastr-color: 76, 170, 229;
}
.notification-container:not(.notification-container-empty) .notification.notification-info:hover {
  --toastr-color: 6, 156, 249;
}
.notification-container:not(.notification-container-empty) .notification.notification-info::before {
  content: "\\f06a";
}
.notification-container:not(.notification-container-empty) .notification .notification-message {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
  padding-inline: 20px;
  padding-block: 10px;
  background: white;
  color: rgb(var(--toastr-color));
}

.notification-container-empty {
  display: none;
}

.rt-table .rdtPicker {
  position: fixed;
}

.diff-value-change {
  display: flex;
  flex-direction: row;
}

.advanced-management-system-list {
  margin-bottom: 0 !important;
}

.advanced-management-system-list .data-field-permission-cell {
  text-align: center;
}

.advanced-management-system-list .data-field-permission-header {
  text-align: center;
}

.advanced-management-system-list .data-field-permission-header p {
  margin-bottom: 0;
  font-weight: lighter;
}

.advanced-management-system-list .data-field-permission-header p:first-child {
  margin-bottom: 0;
  font-weight: bold;
}

.advanced-management-system-list td, .advanced-management-system-list th {
  background: white;
  border-inline-start: solid 1px #d5d5d5;
  border-inline-end: solid 1px #d5d5d5;
}

.advanced-management-system-list th:first-child, .advanced-management-system-list td:first-child {
  position: -webkit-sticky;
  position: sticky;
  inset-inline-start: 0;
  z-index: 1;
  border-inline-start: none;
  border-inline-end: none;
}

.x-scroll-content {
  overflow-x: hidden;
}

.table-caption {
  text-align: center;
  background: white;
  padding-bottom: 10px;
  padding-top: 5px;
}

[data-rbd-droppable-id] {
  min-height: 20px;
}

.data-grid-list-table .rt-table {
  max-height: 71vh;
}

.data-list-table .rt-table {
  max-height: 65vh;
}

.react-table {
  position: relative;
  display: block;
}
.react-table .-loading {
  display: block;
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  opacity: 1;
  z-index: 4;
  pointer-events: all;
}
.react-table .-loading .-loading-inner {
  height: 100%;
}
.react-table .rt-table {
  border-spacing: 0;
  overflow-x: hidden !important;
  overflow-y: auto;
  /*border-top: solid 1px #ccc !important;*/
}
.react-table .rt-table .rt-thead {
  top: 0;
  position: sticky;
  z-index: 2;
}
.react-table .rt-table .rt-tbody {
  z-index: 1;
}
.react-table .rt-table .rt-tfoot {
  bottom: 0;
  position: sticky;
  z-index: 2;
}
.react-table .rt-table .tr :last-child .td {
  border-bottom: 0;
}
.react-table .rt-table .th,
.react-table .rt-table .td {
  margin: 0;
  background-color: #fff;
  position: relative;
}
.react-table .rt-table .th :last-child:not(button, .system-input-container),
.react-table .rt-table .td :last-child:not(button, .system-input-container) {
  border-inline-end: 0;
}
.react-table .rt-table .th .resizer,
.react-table .rt-table .td .resizer {
  --color-a: #f4f4f4;
  --color-b: #e5e7eb;
  display: inline-block;
  background: transparent;
  width: 6px;
  height: 100%;
  position: absolute;
  inset-inline-end: 0px;
  inset-inline-start: initial;
  top: 0;
  z-index: 1;
  touch-action: none;
  background-image: linear-gradient(90deg, var(--color-a) 25%, var(--color-b) 25%, var(--color-b) 50%, var(--color-a) 50%, var(--color-a) 75%, var(--color-b) 75%, var(--color-b) 100%);
  background-size: 8px 8px;
  opacity: 0;
}
.react-table .rt-table .th .resizer:hover,
.react-table .rt-table .td .resizer:hover {
  opacity: 1;
}
.react-table .rt-table .th:hover .resizer,
.react-table .rt-table .td:hover .resizer {
  opacity: 0.6;
}
.react-table .rt-table .th:hover .resizer:hover,
.react-table .rt-table .td:hover .resizer:hover {
  opacity: 1;
}
.react-table .rt-table [data-sticky-td] {
  position: sticky;
}
.react-table .rt-table [data-sticky-last-left-td] {
  box-shadow: 2px 0px 3px #ccc;
}
.react-table .rt-table [data-sticky-first-right-td] {
  box-shadow: -2px 0px 3px #ccc;
}
.react-table .rt-table.sticky {
  overflow: scroll;
}

.pagination {
  padding: 0.5rem;
}

.log-list-table .rt-table, .db-audit-log-list-table .rt-table, .translations-table .rt-table {
  max-height: 66vh;
}

.service-list-table .rt-table {
  max-height: 65vh;
}

.data-list-report-table .rt-table {
  max-height: 58vh;
}

.translations-table .rt-table .rt-thead > div {
  background: #f4f4f4;
}
.translations-table .message-content {
  width: 100%;
  height: 100%;
}

.table-scroll-horizontal > div.rt-table {
  overflow-x: auto !important;
}

.user-rights-management .permissions-part .permissions-table > .filters-columns {
  position: sticky;
  top: 0;
  z-index: 10;
}

.json-data-view .field-type-array .json-data-view-array > tbody > tr:not(:first-child) {
  border-top: 1px solid #dee2e6;
}
.json-data-view .field-type-object + .field-type-array {
  border-top: 1px solid #dee2e6;
}

.translations-table .translation-cell-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 10px;
}

.data-list-table .editgrid-cell button, .data-grid-list-table .editgrid-cell button {
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-top: 0;
}

.app-footer {
  position: fixed;
  bottom: 0;
  z-index: 9;
  inset-inline: 0;
}

.data-view-data-list-table .rt-table {
  max-height: 70vh;
}
.data-view-data-list-table .rt-table .btn-link {
  padding: 0;
  margin: 0;
}
.data-view-data-list-table .rt-table .btn-link > i {
  padding-inline-end: 5px;
}

.data-view-list-table .rt-table {
  max-height: 70vh;
}

.app-container.app-iframe .app-wrapper {
  padding: 0;
}
.app-container.app-iframe .app-wrapper .data-view-list-container {
  height: 100vh;
}
.app-container.app-iframe .app-wrapper .data-view-list-container > div .nav {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.app-container.app-iframe .app-wrapper .newtable {
  padding-top: 0;
}
.app-container.app-iframe .nav-pages li.nav-item:first-child a.nav-link {
  padding-inline-start: 0px;
}
.app-container.app-iframe .pagination {
  container-type: inline-size;
  container-name: iframe-pagination;
  min-width: 652px;
}

.data-view-embed-code {
  height: 100%;
}
.data-view-embed-code iframe {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 6px;
  padding: 6px 16px 2px;
  border: solid 1px rgba(0, 0, 0, 0.05);
}

.data-view-filter-dropdown {
  z-index: 12;
}

.data-view-list-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.data-view-list-container .filters-row {
  background-color: transparent;
}
.data-view-list-container .filters-row .columns-toggler {
  margin-inline-start: 6px;
}
.data-view-list-container .filters-row .print-view {
  border-radius: 6px;
  padding: 0 0.6rem;
  font-weight: 500;
  font-size: 12px;
  color: #1b255f !important;
  height: 32px;
  transition-duration: 0.3s;
}
.data-view-list-container .filters-row .print-view:hover {
  background-color: #EAEDF2;
}
.data-view-list-container ul.nav.nav-tabs {
  padding: 0;
}
.data-view-list-container ul.nav.nav-tabs li.nav-item {
  box-shadow: none !important;
}
.data-view-list-container ul.nav.nav-tabs li.nav-item a.nav-link {
  text-transform: uppercase;
}
.data-view-list-container .data-view-list-table-container {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  height: 0;
}
.data-view-list-container .data-view-list-table-container > .tab-content {
  height: 100%;
  width: 100%;
  box-shadow: none;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active {
  height: 100%;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table {
  width: 100%;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table.data-view-data-list-table .rt-table {
  max-height: calc(100vh - 240px);
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table.data-view-data-list-table .rt-table .rt-thead .tr:first-child:not(:last-child) .th[role=columnheader] {
  border-inline-end: solid 1px #A3ADC5;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table.data-view-data-list-table .rt-table .rt-tfoot {
  bottom: -1px;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table.data-view-data-list-table .rt-table .rt-tfoot .tr .td {
  box-shadow: none;
  background-color: #DAE4EE;
  color: #1b255f;
  align-items: center;
  padding-inline-start: 15px !important;
  padding-inline-end: 15px !important;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table.data-view-data-list-table .rt-table .rt-tfoot .tr .td.type-number {
  text-align: right;
}
.data-view-list-container .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table .pagination span {
  white-space: nowrap;
}
.data-view-list-container .data-view-list-table-container.data-view-hidden-pagination .tab-content > .tab-pane.active > div.react-table > .rt-table {
  max-height: 100%;
}
.data-view-list-container.tableoptions--closed .data-view-list-table-container > .tab-content > .tab-pane.active > div.react-table.data-view-data-list-table .rt-table {
  max-height: calc(100vh - 236px);
}
.data-view-list-container .rt-tfoot {
  margin-top: 63px;
}
.data-view-list-container .react-table .rt-table .rt-tbody .tr .td:is(.type-array_of_file, .type-file):has(button) {
  padding-inline: 6px;
}

.drop-drag-fields-view > .Pane:first-child > div > .react-table > .rt-table {
  overflow-y: auto;
}
.drop-drag-fields-view > .Pane:last-child > div {
  height: 100%;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table {
  height: 100%;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table .rt-tbody {
  flex: auto;
  min-height: initial !important;
  display: flex;
  flex-direction: column;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table .rt-tbody > div {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table .rt-tbody > div .tr {
  flex: initial !important;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table .rt-tbody > div :is(.drop-placeholder, .droppable-placeholder) {
  flex: 1;
  display: grid;
  place-items: center;
  min-height: 150px;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table.empty-rows {
  height: calc(100% - 36px);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table.empty-rows > .rt-tbody {
  height: calc(100% - 36px);
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table.empty-rows > .rt-tbody > div {
  display: table;
  width: 100%;
  text-align: center;
  height: 100%;
  border-bottom: solid 2px #ccc !important;
  border-inline-start: solid 2px #ccc !important;
  border-inline-end: solid 2px #ccc !important;
  transition: 0.3s;
  font-weight: bold;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table.empty-rows > .rt-tbody > div > :where(.drop-placeholder, .droppable-placeholder) {
  display: table-cell;
  vertical-align: middle;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table.empty-rows > .rt-tbody > div.dragging-over {
  background: #63a386;
  color: #fff;
  border-color: #63a386;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table:not(.empty-rows) > .rt-tbody > div {
  transition: 0.3s;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table:not(.empty-rows) > .rt-tbody > div > :where(.drop-placeholder, .droppable-placeholder) {
  transition: 0.3s;
  text-align: center;
  border: dashed 2px #ccc !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.drop-drag-fields-view > .Pane:last-child > div > .react-table > .rt-table:not(.empty-rows) > .rt-tbody > div.dragging-over > .droppable-placeholder {
  background: #63a386;
  color: #fff;
  border-color: #63a386;
}
.drop-drag-fields-view > .Pane {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.app-header:has(.appbar--collapsed) + .app-main-content-wrapper .drop-drag-fields-view > .Pane {
  max-height: calc(100vh - 120px);
}

.search-field {
  margin-bottom: 6px;
  cursor: pointer;
  border: solid 1px rgba(74, 98, 136, 0.2);
  border-radius: 6px;
}
.search-field input {
  font-weight: 400;
  color: rgb(27, 37, 95);
  border: none;
  padding: 0;
  height: 24px;
  font-size: 14px;
  line-height: 2;
}
.search-field input:focus-visible {
  outline: none;
}
.search-field:hover, .search-field:focus-within {
  border-color: #80bdff;
}

.flex-grow-1 {
  flex-grow: 1;
}

.permission-row .permission-status {
  display: flex;
  flex-direction: column;
}
.permission-row .permission-status > div {
  flex: 1;
  align-items: center;
  display: flex;
  height: 40px;
}

.btn.file-link {
  text-transform: inherit !important;
}

.react-table .td > button {
  padding: 0;
  margin: 0;
}

.react-table.db-audit-log-list-table .rt-table .rt-tbody .tr .td {
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}

button.db-records {
  display: inline-block !important;
}
button.db-records + span {
  margin-inline-start: 5px;
}

.select-another-db-block > h2 {
  margin-bottom: 5px !important;
}
.select-another-db-block div.db-link {
  display: block;
}
.select-another-db-block div.db-link > a {
  color: #333;
}
.select-another-db-block div.db-link > a:hover {
  text-decoration: none !important;
  color: #99BBCD;
}
.select-another-db-block div.db-link > a span.db-code {
  font-weight: 700;
  color: #777777;
  text-transform: uppercase;
  font-size: 82%;
  margin-inline-start: 5px;
}

.diagram-container {
  height: 100%;
  display: flex;
  background: #F1F2F4;
}
.diagram-container > * {
  height: 100%;
  min-height: 100%;
  width: 100%;
}
.diagram-container > * > * {
  overflow: visible !important;
}
.diagram-container > * > * .node {
  z-index: 1;
}
.diagram-container > * > * .node:hover {
  z-index: 100;
}
.diagram-container > * > * .node div {
  white-space: nowrap !important;
}

.app-diagram-wrapper {
  height: 100%;
  position: relative;
}

.advanced-management-system-list td.auth-name {
  padding: 3px 11px;
  text-align: left;
  font-style: italic;
  color: #909090;
}

.user-management-table td.auth-name {
  padding: 3px 11px;
  text-align: left;
  font-style: italic;
  color: #909090;
}

.user-management-services .auth-name {
  text-align: left;
  font-style: italic;
  color: #909090;
}
.user-management-services li.auth-name {
  list-style-type: none;
}

.user-management-service-popover-body .auth-name {
  text-align: left;
  font-style: italic;
  color: #909090;
}

span > span.auth-name {
  margin-inline-start: 3px;
  text-align: left;
  font-style: italic;
  color: #909090;
}

.role-users-management-content .toggle-icon {
  height: 30px;
  align-items: center;
  cursor: pointer;
  font-size: 28px;
  transition-duration: 0.2s;
}
.role-users-management-content tr > td:last-child {
  padding-inline-start: 10px;
}
.role-users-management-content tr.auth-group > td:first-child {
  text-align: left;
  font-style: italic;
  color: #909090;
}
.role-users-management-content tr.anonymous-user td:first-child {
  font-weight: bold;
}

.newtable > .nav {
  position: relative;
}
.newtable > .nav .db-options-buttons > .search--table {
  position: absolute;
  top: 3px;
  inset-inline-end: 46px;
  visibility: hidden;
  width: 60%;
  background-color: #f4f4f4;
}
.newtable > .nav .db-options-buttons > .search--table.search--opened {
  visibility: visible;
}
.newtable > .nav .db-options-buttons .options-buttons {
  white-space: nowrap;
}

.audit-log-detail-view table tr > td:first-child {
  white-space: nowrap;
}
.audit-log-detail-view table tr > td:last-child {
  word-break: break-all;
}

.blockchain-icon {
  width: 22px;
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.blockchain-detail-popover .popover-header {
  background-color: #f7f7f7;
}
.blockchain-detail-popover .blockchain-algorithm {
  font-style: italic;
  color: #7a7a7a;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.force-select {
  -webkit-user-select: all; /* Chrome 49+ */
  -moz-user-select: all; /* Firefox 43+ */
  -ms-user-select: all; /* No support yet */
  user-select: all; /* Likely future */
}

.header-vertical-align-bottom {
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
}

/* Celia design */
.service-swagger-ui > .swagger-ui :where(.highlight-code, .opblock-section-header) {
  text-align: start;
}
.service-swagger-ui > .swagger-ui .opblock-title {
  display: flex;
}
.service-swagger-ui > .swagger-ui > div {
  display: none;
}
.service-swagger-ui > .swagger-ui > div:last-child {
  display: block;
}
.service-swagger-ui > .swagger-ui > div > .wrapper {
  padding: 0;
}
.service-swagger-ui > .swagger-ui > div > .wrapper .opblock-summary button.opblock-summary-control {
  pointer-events: none;
}
.service-swagger-ui > .swagger-ui > div > .wrapper .opblock-summary button.opblock-summary-control svg.arrow {
  display: none;
}
.service-swagger-ui > .swagger-ui > div > .wrapper .opblock-summary button.authorization__btn {
  display: none;
}
.service-swagger-ui > .swagger-ui > div > .wrapper + .wrapper {
  display: none;
}
.service-swagger-ui > .swagger-ui > div > .wrapper .opblock-tag-section > h3.opblock-tag {
  display: none;
}
.service-swagger-ui > .swagger-ui .information-container {
  display: none;
}
.service-swagger-ui > .swagger-ui .scheme-container {
  display: none;
}

.report-column-selection .dropdown {
  width: 100%;
}
.report-column-selection .dropdown > button {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.report-column-selection .dropdown > button .selected-field::after {
  content: ", ";
}
.report-column-selection .dropdown > button .selected-field:last-child::after {
  content: "";
}
.report-column-selection .dropdown > button .selected-field + .selected-field {
  margin-inline-start: 3px;
}

.monitor-tooltip .tooltip-inner {
  max-width: none;
}

.user-username {
  font-size: 10px;
}

.data-list-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 135px);
  gap: 20px;
}
.data-list-container .data-list-table-container {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  height: 0;
}
.data-list-container .data-list-table-container > .SplitPane .Pane > .tab-pane {
  height: 100%;
}
.data-list-container .data-list-table-container > .SplitPane .Pane > .tab-pane > .react-table {
  height: 100%;
}
.data-list-container .data-list-table-container > .SplitPane .Pane > .tab-pane > .react-table > .rt-table {
  max-height: calc(100% - 36px - 25px);
  overflow-x: auto !important;
}
.data-list-container .data-list-table-container > .tab-content {
  width: 100%;
  height: 100%;
  box-shadow: none;
}
.data-list-container .data-list-table-container > .tab-content > .tab-pane {
  width: 100%;
  height: 100%;
}
.data-list-container .data-list-table-container > .tab-content > .tab-pane > .react-table {
  width: 100%;
  height: 100%;
}
.data-list-container .data-list-table-container > .tab-content > .tab-pane > .react-table > .rt-table {
  max-height: calc(100% - 36px - 25px);
  overflow-x: auto !important;
}
.data-list-container .data-list-table-container.main-data-split-container .Pane2 {
  min-width: 200px;
}
.data-list-container .data-list-table-container.main-data-split-container .Pane2 > div {
  height: 100%;
}

.document-image-view {
  text-align: center;
}

.document-viewer-pagination {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(3, 1fr);
  padding-bottom: 1rem;
  align-items: center;
}
.document-viewer-pagination .previous {
  text-align: start;
}
.document-viewer-pagination .next {
  text-align: end;
}
.document-viewer-pagination .current-page {
  text-align: center;
}

.trash-button {
  display: inline-block;
}
.trash-button .button {
  display: block;
}

.form-control-color {
  width: 27px;
}

.entity-relationship-node {
  position: relative;
  font-family: Arial;
  min-width: 150px;
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.05);
  font-size: 22px;
  --editgrid-node-color: #316896;
  --left-port-color: rgba(0, 0, 0, 0.9);
  --right-port-color: rgba(0, 0, 0, 0.3);
  --level: 1;
  --roundness: 0.65rem;
  --port-hover-color: #f4f4f4;
  border-radius: var(--roundness);
  transition: all 0.2s;
}
.entity-relationship-node .node-description {
  display: none;
  padding: 0 0 16px;
}
.entity-relationship-node .node-description .fa-database {
  font-size: 80px;
}
.entity-relationship-node.summarised {
  box-shadow: none;
  background-color: transparent;
  transition: all 0.2s;
}
.entity-relationship-node.summarised .node-description {
  display: initial;
}
.entity-relationship-node.summarised .expand-collapse-all {
  display: none;
}
.entity-relationship-node .node-header {
  flex-grow: 1;
  padding: 10px 20px;
  margin-bottom: 0;
  color: white;
  font-weight: bold;
  cursor: pointer;
  border-radius: var(--roundness) var(--roundness) 0 0;
  text-align: start;
}
.entity-relationship-node .node-header .options-icon {
  opacity: 0;
  transition: all 0.2s;
  color: white;
}
.entity-relationship-node .node-header .toggle-icon {
  color: white;
}
.entity-relationship-node .node-header.summarised {
  z-index: 5;
  border-radius: var(--roundness);
}
.entity-relationship-node .node-header.summarised .expand-collapse-all {
  display: none;
}
.entity-relationship-node .node-header.summarised + div :is(.node-port, .port-children) {
  z-index: 4;
  position: absolute;
  top: 0;
  visibility: hidden;
  overflow: hidden;
  margin-top: 0;
}
.entity-relationship-node .node-header.summarised + div .port-children {
  margin: 0;
}
.entity-relationship-node:hover {
  z-index: 5;
}
.entity-relationship-node:hover::before {
  z-index: 1;
  content: " ";
  top: -2px;
  left: -100vw;
  position: absolute;
  width: 200vw;
  height: 2px;
  background: -moz-linear-gradient(left, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, 0.5) 50%, rgba(49, 104, 150, 0) 75%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, 0.5) 50%, rgba(49, 104, 150, 0) 75%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, 0.5) 50%, rgba(49, 104, 150, 0) 75%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00316896", endColorstr="#00316896", GradientType=1); /* IE6-9 */
}
.entity-relationship-node:hover::after {
  z-index: 2;
  content: " ";
  top: -100vw;
  left: -2px;
  position: absolute;
  height: 200vw;
  width: 2px;
  background: -moz-linear-gradient(top, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, 0.5) 50%, rgba(49, 104, 150, 0) 75%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, 0.5) 50%, rgba(49, 104, 150, 0) 75%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, 0.5) 50%, rgba(49, 104, 150, 0) 75%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00316896", endColorstr="#00316896", GradientType=0); /* IE6-9 */
}
.entity-relationship-node:hover .node-header {
  z-index: 4;
}
.entity-relationship-node:hover .node-header + div {
  z-index: 3;
}
.entity-relationship-node:hover .options-icon {
  opacity: 1;
  transition: all 0.2s;
}
.entity-relationship-node .node-description {
  flex-grow: 1;
  padding: 10px 20px;
  position: relative;
}
.entity-relationship-node .node-port {
  flex-grow: 1;
  padding: 10px 20px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  width: 100%;
}
.entity-relationship-node .node-port.collapsible {
  color: var(--left-port-color);
  margin-top: 20px;
  transition-duration: 0.1s;
  transition-property: margin-top;
}
.entity-relationship-node .node-port.collapsible .left-port {
  font-weight: 800;
  color: inherit;
  display: flex;
  align-items: center;
}
.entity-relationship-node .node-port.collapsible.field-type-array {
  color: var(--editgrid-node-color);
}
.entity-relationship-node .node-port.collapsible.collapsed {
  margin-top: 0;
  transition-duration: 0.1s;
}
.entity-relationship-node .node-port .collapse-icon {
  margin-inline-end: 10px;
  cursor: pointer;
  border-radius: 15px;
  display: inline-flex;
  line-height: 10px;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  background: #dee2e6;
  font-size: 16px;
}
.entity-relationship-node .node-port.port-connected {
  background: #deecf3;
}
.entity-relationship-node .node-port.port-connected .left-port .circle-porter {
  inset-inline-start: -8px;
}
.entity-relationship-node .node-port.port-connected .right-port .circle-porter {
  inset-inline-end: -8px;
}
.entity-relationship-node .node-port .right-port {
  margin-inline-start: 20px;
  color: var(--right-port-color);
  font-size: 18px;
  align-self: flex-end;
}
.entity-relationship-node .node-port .circle-porter {
  position: absolute;
  top: 23px;
}
.entity-relationship-node .node-port .circle-porter .circle-port {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #ddd;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.entity-relationship-node .node-port .circle-porter .circle-port:hover {
  background: #bbb;
}
.entity-relationship-node .node-port:hover {
  background-color: var(--port-hover-color);
}
.entity-relationship-node .node-port:last-child {
  border-radius: 0 0 var(--roundness) var(--roundness);
}
.entity-relationship-node .port-children {
  margin-bottom: 20px;
  transition-duration: 0.1s;
  transition-property: margin-bottom;
}
.entity-relationship-node .port-children.collapsed {
  position: absolute;
  margin-top: -53px;
  inset-inline-end: 0;
  inset-inline-start: 0;
  visibility: hidden;
}
.entity-relationship-node .port-children.collapsed > .node-port {
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
}
.entity-relationship-node .port-children .node-port {
  padding-inline-start: 29px;
}
.entity-relationship-node .port-children .node-port .left-port {
  margin-inline-start: calc(21px * var(--level));
}
.entity-relationship-node .port-children .node-port .left-port .collapse-icon + .left {
  margin-inline-start: 0 !important;
}
.entity-relationship-node .port-children .node-port .left-port .port + .left {
  margin-inline-start: 9px;
}
.entity-relationship-node .port-children:last-child {
  margin-bottom: 0;
}
.entity-relationship-node .node-header + div > .port-children > .node-port > .left-port > .left {
  margin-inline-start: 0;
}

.diagram-tools-button {
  position: absolute;
  inset-inline-end: 19px;
  bottom: 49px;
  font-size: 30px;
}
.diagram-tools-button + .diagram-tools-button {
  bottom: 89px;
}

.modal-title span + span.db-code {
  margin-inline-start: 5px;
}

.x-road-icon {
  width: 19px;
}

.react-autosuggest__input {
  max-width: 240px;
  height: 30px;
  padding: 10px 20px;
  font-family: Helvetica, sans-serif;
  font-weight: 300;
  font-size: 16px;
  border: 1px solid #aaa;
  border-radius: 4px;
}

.react-autosuggest__input--focused {
  outline: none;
}

.react-autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
  display: none;
}

.react-autosuggest__suggestions-container--open {
  display: block;
  position: absolute;
  border: 1px solid #aaa;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 2;
}

.react-autosuggest__suggestions-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.react-autosuggest__suggestion {
  cursor: pointer;
  padding: 2px 5px;
}

.react-autosuggest__suggestion--highlighted {
  background-color: #ddd;
}

.filter-value > .mustache {
  background-color: #C0D6A0;
  padding: 1px;
  border-radius: 1px;
}

.data-filter-table td.filter-value-column .multi-select {
  min-width: 150px;
}
.data-filter-table td.filter-value-column .multi-select .mustache {
  background-color: #C0D6A0;
}
.data-filter-table td.filter-value-column .multi-select .mustache + div {
  background-color: #C0D6A0;
}

.react-select__single-value .field-label + .field-label::before {
  content: ".";
}

.nested-path-label .field-label + .field-label::before {
  content: ".";
}

@container iframe-pagination (max-width: 652px) {
  .app-container.app-iframe .pagination .page-info {
    margin-inline-end: 1rem;
  }
  .app-container.app-iframe .pagination .ml-5 {
    margin-inline-start: 1rem !important;
  }
}
.resize-sensor {
  direction: ltr !important;
}`, "",{"version":3,"sources":["webpack://./assets/src/css/main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,wBAAA;AAEF;;AACA;EACE,kBAAA;EACA,wBAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;;EAEE,YAAA;AAEF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,sBAAA;EACA,mCAAA;EACA,uBAAA;EACA,kCAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yBAAA;EACA,WAAA;EACA,yCAAA;AAAJ;;AAMI;EACE,uBAAA;EACA,yDAAA;AAHN;AAKM;EACE,yBAAA;EACA,yBAAA;AAHR;AAUM;EACE,oBAAA;AARR;AAUQ;EACE,yBAAA;EACA,sBAAA;AARV;;AAeA;EACE,aAAA;AAZF;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAZF;;AAeA;EACE,UAAA;AAZF;;AAeA;EACE,wBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAZF;;AAeA;;;EAGE,wBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAZF;;AAeA;EACE,qBAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,iBAAA;AAZF;;AAeA,WAAA;AACA;EACE,YAAA;AAZF;;AAeA;EACE,wBAAA;EACA,6BAAA;AAZF;;AAeA;;;;;;;;;;;;;;EAcE,kBAAA;EACA,iBAAA;EACA,iBAAA;AAZF;AAcE;;;;;;;;;;;;;;EACE,eAAA;AACJ;;AAGA;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,qCAAA;EACA,iCAAA;AAAF;;AAGA;;EAEE,oCAAA;AAAF;;AAGA,gBAAA;AACA;EACE,uBAAA;EACA,qCAAA;AAAF;;AAGA;EACE,6BAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAKU;EACE,WAAA;AAHZ;;AAWA;EACE,gBAAA;AARF;;AAWA;;EAEE,6BAAA;EACA,yBAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;;EAEE,kBAAA;AARF;;AAWA;;EAEE,kDAAA;EACA,gDAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,UAAA;EACA,SAAA;AARF;;AAWA;;EAEE,wBAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,yBAAA;EACA,0BAAA;AARF;;AAWA;EACE,yBAAA;EACA,mCAAA;EACA,iCAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,2BAAA;AARF;;AAWA;EACE,iBAAA;EACA,2BAAA;AARF;;AAWA;;;;EAIE,mCAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;;EAEE,kDAAA;AARF;;AAWA;;;;;;;;EAQE,mCAAA;AARF;;AAWA;;EAEE,kDAAA;AARF;;AAWA;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AARF;;AAWA;EACE,UAAA;EACA,eAAA;AARF;;AAWA;EACE,uBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,kDAAA;AARF;;AAWA;EACE,mDAAA;AARF;;AAWA;;;EAGE,gDAAA;EACA,kDAAA;AARF;;AAWA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AARF;;AAWA;EACE,uCAAA;EACA,sCAAA;EACA,0BAAA;EACA,wBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;EACA,UAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AARF;AAUE;EACE,SAAA;EACA,eAAA;AARJ;AAUI;EACE,+BAAA;AARN;AAYE;EACE,aAAA;EACA,SAAA;AAVJ;AAaE;EACE,8BAAA;EACA,YAAA;AAXJ;;AAeA;EACE,yCAAA;EACA,UAAA;EACA,mBAAA;AAZF;;AAeA;EACE,iCAAA;EACA,gBAAA;EACA,sBAAA;AAZF;;AAeA;EACE,YAAA;EACA,oBAAA;AAZF;;AAeA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,qBAAA;AAZF;;AAeA;;EAEE,OAAA;AAZF;;AAeA;EACE,8BAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAZF;;AAeA;;EAEE,sBAAA;EACA,oBAAA;EACA,gCAAA;EACA,YAAA;EACA,oBAAA;EACA,kCAAA;EACA,WAAA;EACA,mBAAA;AAZF;;AAeA;;;;;;EAME,oBAAA;EACA,UAAA;AAZF;;AAeA;;EAEE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAZF;;AAeA;;EAEE,oBAAA;AAZF;;AAeA;;;;EAIE,aAAA;AAZF;;AAeA;EACE,oCAAA;AAZF;;AAeA;EACE,wBAAA;AAZF;;AAeA;EACE,sBAAA;AAZF;;AAeA;EACE,YAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,SAAA;EACA,aAAA;AAZF;;AAeA;EACE,6BAAA;AAZF;;AAeA;EACE,0BAAA;AAZF;AAeI;EACE,aAAA;AAbN;AAgBI;EACE,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AAdN;AAkBM;EACE,UAAA;EACA,iCAAA;EACA,4BAAA;EACA,yBAAA;AAhBR;AAsBI;EACE,wBAAA;EACA,uBAAA;AApBN;;AAyBA;;EAEE,qBAAA;AAtBF;;AAyBA;;EAEE,gBAAA;AAtBF;;AA0BA;EACE,UAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,cAAA;EACA,eAAA;AAvBF;;AA2BE;EACE,oBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AAzBJ;AA2BI;EACE,yBAAA;AAzBN;;AAgCI;EACE,2BAAA;AA7BN;AAkCI;EACE,6BAAA;AAhCN;AAoCE;EACE,qBAAA;AAlCJ;AAoCI;EACE,gBAAA;EACA,cAAA;AAlCN;AAqCI;EACE,gBAAA;EACA,cAAA;AAnCN;AAsCI;EACE,0BAAA;AApCN;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,gBAAA;EACA,oBAAA;AAtCF;;AAyCA;EACE,gBAAA;EACA,yBAAA;AAtCF;AAwCE;EACE,yBAAA;EACA,0BAAA;AAtCJ;AAyCE;EACE,iBAAA;EACA,gBAAA;AAvCJ;AA2CI;EACE,mBAAA;EACA,8BAAA;AAzCN;AA2CM;EACE,yBAAA;AAzCR;AA8CM;EACE,yBAAA;AA5CR;AAiDE;EACE,aAAA;EACA,iBAAA;EACA,SAAA;AA/CJ;;AAqDA;;;EAAA;AAKA;;EAEE,6BAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,oBAAA;EACA,6BAAA;EACA,iBAAA;EACA,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,4BAAA;EACA,oCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iCAAA;EACA,gJAAA;EACA,yBAAA;EACA,wCAAA;EACA,iCAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;AAnDF;;AAsDA;;;;;;EAME,sBAAA;EACA,oCAAA;EACA,gCAAA;AAnDF;;AAsDA;EACE,kCAAA;AAnDF;;AAsDA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;AAnDF;;AAsDA;EACE;IACE,qBAAA;EAnDF;EAqDA;IACE,qBAAA;EAnDF;AACF;AAuDA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;AArDF;;AAwDA;EACE,+BAAA;EACA,uBAAA;AArDF;;AAwDA;EACE,YAAA;EACA,cAAA;EACA,4CAAA;EACA,+CAAA;EACA,kBAAA;EACA,WAAA;AArDF;;AAwDA;EACE,wCAAA;EACA,2CAAA;AArDF;;AAwDA;EACE,WAAA;EACA,cAAA;EACA,qDAAA;EACA,mDAAA;EACA,kBAAA;AArDF;;AAwDA;EACE,iDAAA;EACA,+CAAA;AArDF;;AAwDA;EACE,mBAAA;AArDF;;AAwDA;EACE,yBAAA;AArDF;;AAyDA;EACE,6BAAA;AAtDF;;AAyDA,gBAAA;AACA;EACE,UAAA;EACA,oBAAA;AAtDF;;AAyDA;EACE,UAAA;EACA,uBAAA;AAtDF;;AAyDA;EACE,aAAA;AAtDF;;AAyDA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;AAtDF;;AAyDA;;EAEE,YAAA;EACA,yBAAA;AAtDF;;AAyDA;;;;;EAME,aAAA;EACA,YAAA;EACA,sBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;;EAEE,iBAAA;EACA,eAAA;AAvDF;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA;;EAEE,eAAA;EACA,sBAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,sBAAA;EACA,iBAAA;EACA,0BAAA;AAvDF;;AA0DA;;EAEE,yBAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,aAAA;AAvDF;;AA0DA;EACE,kBAAA;AAvDF;;AA0DA;EACE,aAAA;AAvDF;;AA0DA;EACE,aAAA;AAvDF;;AA0DA;EACE,iBAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,mBAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAvDF;;AA0DA;EACE,WAAA;AAvDF;;AA0DA;EACE,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,kCAAA;AAvDF;;AA0DA;EACE,+BAAA;AAvDF;;AA0DA;EACE,gBAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,4BAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA2DE;EACE,yBAAA;EACA,oBAAA;EACA,gBAAA;AAxDJ;;AA6DA,YAAA;AACA;EACE,wBAAA;AA1DF;;AA6DA;EACE,gCAAA;AA1DF;;AA8DE;;;EAGE,gBAAA;AA3DJ;AA8DE;EACE,kBAAA;AA5DJ;AA+DM;EACE,cAAA;AA7DR;AAgEU;EACE,YAAA;AA9DZ;AAsEI;EACE,gBAAA;AApEN;AAsEM;EACE,yBAAA;AApER;AAsEQ;EACE,yBAAA;AApEV;;AA2EA;EACE,YAAA;AAxEF;;AA2EA;EACE,OAAA;AAxEF;;AA2EA;EACE,mBAAA;EACA,sBAAA;AAxEF;;AA2EA;EACE,eAAA;AAxEF;;AA2EA;;EAEE,gBAAA;EACA,cAAA;AAxEF;;AA2EA;EACE,gBAAA;EACA,cAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAxEF;AA0EE;EACE,gBAAA;EACA,iBAAA;AAxEJ;AA2EE;EACE,aAAA;AAzEJ;;AA6EA;EACE,eAAA;EACA,kBAAA;AA1EF;;AA6EA;EACE,qCAAA;EACA,WAAA;AA1EF;;AA6EA;EACE,qCAAA;AA1EF;;AA6EA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,uBAAA;AA1EF;;AA6EA;;EAEE,gBAAA;AA1EF;;AA6EA;EACE,6BAAA;AA1EF;;AA6EA;EACE,SAAA;EACA,WAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AA1EF;;AA6EA;;EAEE,eAAA;AA1EF;;AA6EA;EACE,WAAA;AA1EF;;AA6EA;EACE,WAAA;EACA,2BAAA;AA1EF;;AA6EA;EACE,YAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,gBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,qBAAA;AA1EF;;AA6EA;EACE,yBAAA;EACA,qBAAA;EACA,aAAA;AA1EF;;AA6EA;EACE,SAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,SAAA;AA1EF;AA4EE;EACE,iBAAA;AA1EJ;AA6EE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,0BAAA;EACA,iDAAA;EACA,0BAAA;EACA,0CAAA;EACA,kBAAA;EACA,uCAAA;EACA,oBAAA;EACA,uDAAA;EACA,kCAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AA3EJ;AA6EI;EACE,kCAAA;EACA,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,eAAA;AA3EN;AA8EI;EACE,4BAAA;AA5EN;AA8EM;EACE,4BAAA;AA5ER;AA+EM;EACE,gBAAA;AA7ER;AAiFI;EACE,2BAAA;AA/EN;AAiFM;EACE,2BAAA;AA/ER;AAkFM;EACE,gBAAA;AAhFR;AAoFI;EACE,6BAAA;AAlFN;AAoFM;EACE,4BAAA;AAlFR;AAqFM;EACE,gBAAA;AAnFR;AAuFI;EACE,4BAAA;AArFN;AAuFM;EACE,2BAAA;AArFR;AAwFM;EACE,gBAAA;AAtFR;AA0FI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;AAxFN;;AA6FA;EACE,aAAA;AA1FF;;AA6FA;EACE,eAAA;AA1FF;;AA6FA;EACE,aAAA;EACA,mBAAA;AA1FF;;AA6FA;EACE,2BAAA;AA1FF;;AA6FA;EACE,kBAAA;AA1FF;;AA6FA;EACE,kBAAA;AA1FF;;AA6FA;EACE,gBAAA;EACA,oBAAA;AA1FF;;AA6FA;EACE,gBAAA;EACA,iBAAA;AA1FF;;AA6FA;EACE,iBAAA;EACA,sCAAA;EACA,oCAAA;AA1FF;;AA6FA;EACE,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;EACA,uBAAA;AA1FF;;AA6FA;EACE,kBAAA;AA1FF;;AA6FA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AA1FF;;AA6FA;EACE,gBAAA;AA1FF;;AA8FE;EACE,gBAAA;AA3FJ;;AAgGE;EACE,gBAAA;AA7FJ;;AAiGA;EACE,kBAAA;EACA,cAAA;AA9FF;AAgGE;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;AA9FJ;AAgGI;EACE,YAAA;AA9FN;AAkGE;EACE,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,yCAAA;AAhGJ;AAkGI;EACE,MAAA;EACA,gBAAA;EACA,UAAA;AAhGN;AAmGI;EACE,UAAA;AAjGN;AAoGI;EACE,SAAA;EACA,gBAAA;EACA,UAAA;AAlGN;AAuGQ;EACE,gBAAA;AArGV;AA0GI;;EAEE,SAAA;EACA,sBAAA;EACA,kBAAA;AAxGN;AA0GM;;EACE,oBAAA;AAvGR;AA0GM;;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EACA,qLAAA;EACA,wBAAA;EACA,UAAA;AAvGR;AAyGQ;;EACE,UAAA;AAtGV;AA2GQ;;EACE,YAAA;AAxGV;AA0GU;;EACE,UAAA;AAvGZ;AA6GI;EACE,gBAAA;AA3GN;AA8GI;EACE,4BAAA;AA5GN;AA+GI;EACE,6BAAA;AA7GN;AAgHI;EACE,gBAAA;AA9GN;;AAoHA;EACE,eAAA;AAjHF;;AAqHE;EACE,gBAAA;AAlHJ;;AAuHE;EACE,gBAAA;AApHJ;;AAyHE;EACE,gBAAA;AAtHJ;;AA4HI;EACE,mBAAA;AAzHN;AA6HE;EACE,WAAA;EACA,YAAA;AA3HJ;;AA+HA;EACE,2BAAA;AA5HF;;AAiII;EACE,gBAAA;EACA,MAAA;EACA,WAAA;AA9HN;;AAoIE;EACE,6BAAA;AAjIJ;AAoIE;EACE,6BAAA;AAlIJ;;AAwIE;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,iBAAA;AArIJ;;AA2II;EACE,oBAAA;EACA,gBAAA;EACA,aAAA;AAxIN;;AA6IA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AA1IF;;AA8IE;EACE,gBAAA;AA3IJ;AA6II;EACE,UAAA;EACA,SAAA;AA3IN;AA6IM;EACE,uBAAA;AA3IR;;AAkJE;EACE,gBAAA;AA/IJ;;AAoJE;EACE,UAAA;AAjJJ;AAmJI;EACE,aAAA;AAjJN;AAoJQ;EACE,oCAAA;EACA,qCAAA;AAlJV;AAuJI;EACE,cAAA;AArJN;AA0JM;EACE,yBAAA;AAxJR;AA4JE;EACE,2BAAA;EACA,iCAAA;EACA,gBAAA;AA1JJ;;AAkKA;EACE,YAAA;AA/JF;AAiKE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AA/JJ;;AAmKA;EACE,WAAA;AAhKF;;AAmKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAhKF;AAkKE;EACE,6BAAA;AAhKJ;AAkKI;EACE,wBAAA;AAhKN;AAmKI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;AAjKN;AAmKM;EACE,yBAAA;AAjKR;AAuKI;EACE,UAAA;AArKN;AAwKQ;EACE,2BAAA;AAtKV;AAyKY;EACE,yBAAA;AAvKd;AA+KE;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AA7KJ;AA+KI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AA7KN;AA+KM;EACE,YAAA;AA7KR;AA+KQ;EACE,WAAA;AA7KV;AAgLY;EACE,+BAAA;AA9Kd;AAqLwB;EACE,oCAAA;AAnL1B;AA2Lc;EACE,YAAA;AAzLhB;AA4LkB;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,mCAAA;AA1LpB;AA4LoB;EACE,iBAAA;AA1LtB;AA2MY;EACE,mBAAA;AAzMd;AAuNY;EACE,gBAAA;AArNd;AAoOc;EACE,+BAAA;AAlOhB;AA2OE;EACE,gBAAA;AAzOJ;AA4OI;EACE,mBAAA;AA1ON;;AAmPQ;EACE,gBAAA;AAhPV;AAuPI;EACE,YAAA;AArPN;AAuPM;EACE,YAAA;AArPR;AAuPQ;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AArPV;AAuPU;EACE,UAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;AArPZ;AAuPY;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AArPd;AAuPc;EACE,wBAAA;AArPhB;AAwPc;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAtPhB;AA2PU;EACE,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAzPZ;AA2PY;EACE,yBAAA;AAzPd;AA2Pc;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,8CAAA;EACA,4CAAA;EACA,gBAAA;EACA,iBAAA;AAzPhB;AA2PgB;EACE,mBAAA;EACA,sBAAA;AAzPlB;AA4PgB;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AA1PlB;AAkQc;EACE,gBAAA;AAhQhB;AAkQgB;EACE,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAhQlB;AAoQkB;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAlQpB;AA4QE;EACE,+BAAA;EACA,gBAAA;AA1QJ;;AA8QE;EACE,+BAAA;AA3QJ;;AA+QA;EACE,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,kBAAA;AA5QF;AA8QE;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AA5QJ;AA8QI;EACE,aAAA;AA5QN;AAgRE;EAEE,qBAAA;AA/QJ;;AAmRA;EACE,YAAA;AAhRF;;AAoRE;EACE,aAAA;EACA,sBAAA;AAjRJ;AAmRI;EACE,OAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAjRN;;AAsRA;EACE,kCAAA;AAnRF;;AAwRI;EACE,UAAA;EACA,SAAA;AArRN;;AA0RA;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;AAvRF;;AA0RA;EACE,gCAAA;AAvRF;AAyRE;EACE,wBAAA;AAvRJ;;AA4RE;EACE,6BAAA;AAzRJ;AA4RE;EACE,cAAA;AA1RJ;AA4RI;EACE,WAAA;AA1RN;AA4RM;EACE,gCAAA;EACA,cAAA;AA1RR;AA6RM;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,wBAAA;AA3RR;;AAiSA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AA9RF;AAgSE;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AA9RJ;AAgSI;EACE,4BAAA;AA9RN;AAgSM;EASE,UAAA;AAtSR;AAuSQ;EACE,YAAA;AArSV;AAuSQ;EACE,8BAAA;AArSV;;AAiTA;EACE,YAAA;EACA,kBAAA;AA9SF;;AAkTE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA/SJ;;AAoTE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAjTJ;;AAsTE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAnTJ;AAsTE;EACE,qBAAA;AApTJ;;AAyTE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAtTJ;;AA2TE;EACE,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAxTJ;;AA6TE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AA1TJ;AA6TE;EACE,0BAAA;AA3TJ;AA+TI;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AA7TN;AAkUI;EACE,iBAAA;AAhUN;;AAsUE;EACE,kBAAA;AAnUJ;AAsUM;EACE,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AApUR;AAsUQ;EACE,mBAAA;AApUV;AAwUM;EACE,mBAAA;AAtUR;;AAgVQ;EACE,mBAAA;AA7UV;AAgVQ;EACE,qBAAA;AA9UV;;AAqVA;EACE,WAAA;EACA,wBAAA;EACA,sBAAA;AAlVF;;AAsVE;EACE,yBAAA;AAnVJ;AAsVE;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,qBAAA;AApVJ;;AAwVA;EACE,wBAAA,EAAA,eAAA;EACA,qBAAA,EAAA,gBAAA;EACA,oBAAA,EAAA,mBAAA;EACA,gBAAA,EAAA,kBAAA;AArVF;;AAwVA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AArVF;;AAwVA,iBAAA;AAII;EACE,iBAAA;AAxVN;AA2VI;EACE,aAAA;AAzVN;AA4VI;EACE,aAAA;AA1VN;AA4VM;EACE,cAAA;AA1VR;AA6VM;EACE,UAAA;AA3VR;AA8VU;EACE,oBAAA;AA5VZ;AA8VY;EACE,aAAA;AA5Vd;AAgWU;EACE,aAAA;AA9VZ;AAkWQ;EACE,aAAA;AAhWV;AAoWU;EACE,aAAA;AAlWZ;AAwWI;EACE,aAAA;AAtWN;AAyWI;EACE,aAAA;AAvWN;;AA6WE;EACE,WAAA;AA1WJ;AA4WI;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA1WN;AA6WQ;EACE,aAAA;AA3WV;AA8WQ;EACE,WAAA;AA5WV;AA+WQ;EACE,wBAAA;AA7WV;;AAsXE;EACE,eAAA;AAnXJ;;AAuXA;EACE,eAAA;AApXF;;AAuXA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,SAAA;AApXF;AAsXE;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AApXJ;AAwXQ;EACE,YAAA;AAtXV;AAwXU;EACE,YAAA;AAtXZ;AAwXY;EACE,oCAAA;EACA,2BAAA;AAtXd;AA6XI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AA3XN;AA6XM;EACE,WAAA;EACA,YAAA;AA3XR;AA6XQ;EACE,WAAA;EACA,YAAA;AA3XV;AA6XU;EACE,oCAAA;EACA,2BAAA;AA3XZ;AAkYM;EACE,gBAAA;AAhYR;AAkYQ;EACE,YAAA;AAhYV;;AAuYA;EACE,kBAAA;AApYF;;AAuYA;EACE,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,oBAAA;EACA,mBAAA;AApYF;AAsYE;EACE,iBAAA;AApYJ;AAuYE;EACE,eAAA;AArYJ;AAwYE;EACE,kBAAA;AAtYJ;;AA0YA;EACE,qBAAA;AAvYF;AAyYE;EACE,cAAA;AAvYJ;;AA2YA;EACE,WAAA;AAxYF;;AA2YA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,eAAA;EACA,8BAAA;EACA,qCAAA;EACA,sCAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,+BAAA;EACA,oBAAA;AAxYF;AA0YE;EACE,aAAA;EACA,iBAAA;AAxYJ;AA0YI;EACE,eAAA;AAxYN;AA2YE;EACE,gBAAA;EACA,6BAAA;EACA,oBAAA;AAzYJ;AA2YI;EACE,gBAAA;AAzYN;AA2YI;EACE,aAAA;AAzYN;AA6YE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,oDAAA;EACA,iBAAA;AA3YJ;AA6YI;EACE,UAAA;EACA,oBAAA;EACA,YAAA;AA3YN;AA8YI;EACE,YAAA;AA5YN;AAgZI;EACE,UAAA;EACA,+BAAA;AA9YN;AAgZM;EACE,aAAA;AA9YR;AAkZQ;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAhZV;AAmZQ;EACE,SAAA;AAjZV;AAuZE;EACE,UAAA;AArZJ;AAuZI;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yHAAA,EAAA,aAAA;EACA,4HAAA,EAAA,4BAAA;EACA,wHAAA,EAAA,qDAAA;EACA,sHAAA,EAAA,UAAA;AArZN;AAwZI;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,wHAAA,EAAA,aAAA;EACA,2HAAA,EAAA,4BAAA;EACA,yHAAA,EAAA,qDAAA;EACA,sHAAA,EAAA,UAAA;AAtZN;AAyZI;EACE,UAAA;AAvZN;AAyZM;EACE,UAAA;AAvZR;AA2ZI;EACE,UAAA;EACA,oBAAA;AAzZN;AA6ZE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AA3ZJ;AA8ZE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AA5ZJ;AA8ZI;EACE,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;AA5ZN;AA8ZM;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA5ZR;AA+ZM;EACE,iCAAA;AA7ZR;AAgaM;EACE,aAAA;EACA,yBAAA;AA9ZR;AAkaI;EACE,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAhaN;AAmaI;EACE,mBAAA;AAjaN;AAoaQ;EACE,wBAAA;AAlaV;AAuaQ;EACE,sBAAA;AAraV;AA0aI;EACE,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;AAxaN;AA2aI;EACE,kBAAA;EACA,SAAA;AAzaN;AA2aM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wEAAA;AAzaR;AA2aQ;EACE,gBAAA;AAzaV;AA8aI;EACE,yCAAA;AA5aN;AA+aI;EACE,oDAAA;AA7aN;AAibE;EACE,mBAAA;EACA,yBAAA;EACA,kCAAA;AA/aJ;AAibI;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AA/aN;AAibM;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;AA/aR;AAmbI;EACE,0BAAA;AAjbN;AAmbM;EACE,8CAAA;AAjbR;AAobU;EACE,iCAAA;AAlbZ;AAsbQ;EACE,wBAAA;AApbV;AAybI;EACE,gBAAA;AAvbN;AA2bE;EACE,sBAAA;AAzbJ;;AA6bA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AA1bF;AA4bE;EACE,YAAA;AA1bJ;;AAgcI;EACE,wBAAA;AA7bN;;AAkcA;EACE,WAAA;AA/bF;;AAkcA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA/bF;;AAkcA;EACE,aAAA;AA/bF;;AAkcA;EACE,4BAAA;EACA,6BAAA;AA/bF;;AAkcA;EACE,aAAA;AA/bF;;AAkcA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,8BAAA;EACA,+BAAA;EACA,UAAA;AA/bF;;AAkcA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AA/bF;;AAkcA;EACE,eAAA;EACA,gBAAA;AA/bF;;AAkcA;EACE,sBAAA;AA/bF;;AAmcE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;AAhcJ;;AAscI;EACE,gBAAA;AAncN;AAqcM;EACE,yBAAA;AAncR;AAqcQ;EACE,yBAAA;AAncV;;AA2cE;EACE,YAAA;AAxcJ;;AA6cE;EACE,YAAA;AA1cJ;;AA8cA;EAEI;IACE,uBAAA;EA5cJ;EA8cE;IACE,oCAAA;EA5cJ;AACF;AAgdA;EACE,yBAAA;AA9cF","sourcesContent":[".app-main-header .search-bar {\n  display: none !important;\n}\n\ndiv.form-input-tooltip {\n  position: relative;\n  padding-inline-end: 30px;\n}\n\ndiv.form-input-tooltip > i {\n  position: absolute;\n  top: 2px;\n  inset-inline-end: 0;\n}\n\ndiv.tooltip {\n  z-index: 2000;\n}\n\n.user-info-menu a.dropdown-item.text-muted.active {\n  background: initial;\n}\n\n.sidebar-header .mini-logo > img {\n  height: 32px;\n}\n\n.app-main-header .logo-img,\n.sidebar-header .logo-img {\n  height: 48px;\n}\n\n\n.jr-card-without-border .jr-card {\n  border: none;\n}\n\n.json-schema-view .jr-card {\n  border-top-left-radius: 0;\n  padding: 3px;\n  margin: 0px;\n}\n\n.json-schema-view .jr-entry-header {\n  padding: 0px;\n  margin: 0px;\n}\n\ntable.json-schema-view-property-info td {\n  text-align: left;\n}\n\n.json-data-view ul {\n  list-style-type: none;\n}\n\n.json-data-view li {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.json-data-view > ul {\n  padding-inline-start: 0;\n}\n\n.json-data-view li > ul {\n  padding-inline-start: 15px;\n}\n\n.json-data-view .badge {\n  margin-inline-end: 3px !important;\n}\n\n.add-new-version-button {\n  margin: 0px !important;\n  margin-inline-start: 3px !important;\n  padding: 3px !important;\n  text-transform: initial !important;\n}\n\n.service-template-text {\n  min-height: 400px;\n}\n\n.rdtOpen .rdtPicker {\n  width: fit-content;\n\n  .has-day-value {\n    background-color: #eeeff2;\n  }\n\n  .selected-range-day {\n    background-color: #428bca;\n    color: #fff;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  }\n}\n\n.fade {\n  .modal-dialog {\n    &.layer {\n      inset-inline-end: -100%;\n      transition-property: inset-inline-end, inset-inline-start;\n\n      &.modal-align-left {\n        inset-inline-end: initial;\n        inset-inline-start: -100%;\n      }\n    }\n  }\n\n  &.show {\n    .modal-dialog {\n      &.layer {\n        inset-inline-end: 0%;\n\n        &.modal-align-left {\n          inset-inline-end: initial;\n          inset-inline-start: 0%;\n        }\n      }\n    }\n  }\n}\n\n.modal-open .theme-option {\n  display: none;\n}\n\ntable.table-scroll {\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  margin: auto;\n  overflow: auto;\n  display: block;\n}\n\ntable.table-scroll > tbody > tr > td {\n  z-index: 1;\n}\n\ntable.table-scroll > thead > tr > th {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\ntable.table-scroll > tfoot,\ntable.table-scroll > tfoot > tr > th,\ntable.table-scroll > tfoot > tr > td {\n  position: -webkit-sticky;\n  position: sticky;\n  bottom: 0;\n  z-index: 0;\n}\n\n.sheet-viewer .sheet-name-list {\n  border-top: 1px solid;\n}\n\n.sheet-viewer .sheet-name-list > span + span {\n  margin-inline-start: 10px;\n}\n\n.sheet-viewer .sheet-name-list > span.selected {\n  font-weight: bold;\n}\n\n/* button */\n.btn.btn-outline-primary:hover {\n  color: white;\n}\n\nbutton {\n  -webkit-appearance: none;\n  background-color: transparent;\n}\n\n.btn.btn-primary,\n.btn.btn-secondary,\n.btn.btn-default,\n.btn.btn-dark,\n.btn.btn-success,\n.btn.btn-danger,\n.btn.btn-warning,\n.btn.btn-outline-primary,\n.btn.btn-outline-secondary,\n.btn.btn-outline-default,\n.btn.btn-outline-dark,\n.btn.btn-outline-success,\n.btn.btn-outline-danger,\n.btn.btn-outline-warning {\n  border-radius: 6px;\n  padding: 3px 16px;\n  line-height: 20px;\n\n  span {\n    font-size: 12px;\n  }\n}\n\n.btn.btn-rounded {\n  border-radius: 15px;\n  padding: 4px 16px;\n  border: none;\n  line-height: 22px;\n}\n\n.btn.btn-dark {\n  background-color: rgba(0, 0, 0, 0.39);\n  border-color: rgba(0, 0, 0, 0.39);\n}\n\n.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled):hover,\n.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {\n  background-color: rgb(230, 230, 230);\n}\n\n/* React Table */\n.ReactTable {\n  border: none !important;\n  border-top: solid 1px #ccc !important;\n}\n\n.rt-table {\n  overflow-x: hidden !important;\n\n  > .rt-thead {\n    background: #f4f4f4;\n\n    > .tr {\n      > .th {\n        .column-filter {\n          > input {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n}\n\n.ReactTable.limited-height .rt-table {\n  max-height: 65vh;\n}\n\n.ReactTable .rt-table.all-hidden .rt-thead .rt-tr .rt-th.rthfc-th-fixed-right,\n.ReactTable .rt-table.all-hidden .rt-tbody .rt-tr-group .rt-tr .rt-td.rthfc-td-fixed-right {\n  background-color: transparent;\n  border-inline-start: none;\n}\n\n.ReactTable .rt-table.all-hidden .rt-tfoot .rt-tr .rt-td.rthfc-td-fixed-right {\n  display: none;\n}\n\n.ReactTable .rt-table.all-hidden .rt-thead .rt-tr .rt-th.rthfc-th-fixed-right,\n.ReactTable .rt-table.all-hidden .rt-tbody .rt-tr-group .rt-tr .rt-td.rthfc-td-fixed-right * {\n  visibility: hidden;\n}\n\n.ReactTable .rt-tbody .rt-th,\n.ReactTable .rt-tbody .rt-td {\n  border-inline-start: solid 1px rgba(0, 0, 0, 0.05);\n  border-inline-end: solid 1px rgba(0, 0, 0, 0.02);\n}\n\n.ReactTable .rt-td:not(.link-cell) {\n  cursor: pointer;\n}\n\n.ReactTable .btn-link {\n  padding: 0;\n  margin: 0;\n}\n\n.ReactTable .btn-link + .btn-link,\n.ReactTable .btn-link + div .btn-link {\n  margin-inline-start: 4px;\n}\n\n.ReactTable.rthfc.-sp .rthfc-th-fixed-right, .rthfc.-sp .rthfc-td-fixed-right {\n  text-align: center !important;\n}\n\n.ReactTable.rthfc .-headerGroups {\n  border: none;\n}\n\n.ReactTable.rthfc .-headerGroups .rt-th {\n  background-color: #D4D9DF;\n  max-width: none !important;\n}\n\n.ReactTable.rthfc .-headerGroups .rt-th.block-cell {\n  background-color: #D4D9DF;\n  border-inline-start: 1px solid #ccc;\n  border-inline-end: 1px solid #ccc;\n}\n\n.ReactTable.rthfc .-headerGroups .rt-th:empty {\n  padding: 0;\n}\n\n.ReactTable .rt-thead.-header {\n  box-shadow: none !important;\n}\n\n.ReactTable .rt-thead.-header[style*=\"top: 1px\"] {\n  top: 0 !important;\n  margin-top: -1px !important;\n}\n\n.rt-th:not(.block-cell) + .block-cell,\n.rt-td:not(.block-cell) + .block-cell,\n.link-cell + .rt-th:not(.link-cell),\n.link-cell + .rt-td:not(.link-cell) {\n  border-inline-start: 1px solid #ccc;\n}\n\n.link-cell {\n  overflow-x: initial !important;\n}\n\n.rt-th.the-last ~ .rt-th,\n.rt-td.the-last ~ .rt-td {\n  border-inline-start: solid 1px rgba(0, 0, 0, 0.05);\n}\n\n.block-cell.editgrid-cell + .rt-th,\n.block-cell.editgrid-cell + .rt-td,\n.rt-th:not(.field-block) + .rt-th.field-block.block-cell,\n.rt-td:not(.field-block) + .rt-td.field-block.block-cell,\n.rt-th.the-last + .rt-th,\n.rt-td.the-last + .rt-td,\n.rt-th.the-first.block-cell,\n.rt-td.the-first.block-cell {\n  border-inline-start: 1px solid #ccc;\n}\n\n.rt-th.field-block + .rt-th.field-block,\n.rt-td.field-block + .rt-td.field-block {\n  border-inline-start: solid 1px rgba(0, 0, 0, 0.05);\n}\n\n.ReactTable.rthfc .-header .rt-th {\n  background-color: #≈;\n  font-weight: 700;\n  text-align: left;\n  font-size: 12px;\n}\n\n.newtable .ReactTable .-pagination {\n  padding: 0;\n  font-size: 10px;\n}\n\n.newtable .ReactTable .-pagination .-btn {\n  background: transparent;\n}\n\n.newtable .ReactTable .-pagination .-pageInfo {\n  margin: 0px 10px;\n}\n\n.newtable .ReactTable .-pagination .-pageJump input {\n  width: 42px;\n  text-align: center;\n  padding: 0px 7px;\n}\n\n.newtable .ReactTable .-pagination .-pageSizeOptions {\n  margin: 0px 10px;\n}\n\n.newtable .ReactTable .rt-thead .rt-th.-sort-asc, .ReactTable .rt-thead .rt-td.-sort-asc {\n  box-shadow: inset 0 3px 0 0 rgba(24, 90, 151, 0.6);\n}\n\n.newtable .ReactTable .rt-thead .rt-th.-sort-desc, .ReactTable .rt-thead .rt-td.-sort-desc {\n  box-shadow: inset 0 -3px 0 0 rgba(24, 90, 151, 0.6);\n}\n\n.newtable .ReactTable.rthfc .-filters .rt-th.rthfc-th-fixed-left-last,\n.newtable .ReactTable.rthfc .rt-th.rthfc-th-fixed-left-last,\n.newtable .ReactTable.rthfc .rt-td.rthfc-td-fixed-left-last {\n  border-inline-end: 1px solid rgba(0, 0, 0, 0.02);\n  border-inline-start: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.newtable .ReactTable .last-updated {\n  white-space: nowrap;\n  text-align: center;\n  width: 142px !important;\n  max-width: 142px !important;\n}\n\n.newtable .nav-tabs {\n  border-top-right-radius: 5px !important;\n  border-top-left-radius: 5px !important;\n  padding-inline-start: 12px;\n  padding-inline-end: 12px;\n  padding-top: 8px;\n  background-color: #99BBCD;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, .15);\n  z-index: 2;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n\n  .nav-pages {\n    gap: 2rem;\n    flex-grow: 1000;\n\n    .nav-item {\n      margin-inline-end: 0 !important;\n    }\n  }\n\n  :where(.add-search, .nav-tools) {\n    display: flex;\n    gap: 1rem;\n  }\n\n  .nav-tools {\n    justify-content: space-between;\n    flex-grow: 1;\n  }\n}\n\n.newtable .tab-content {\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, .15);\n  z-index: 3;\n  background: #f4f4f4;\n}\n\n.newtable .nav-link {\n  padding: 0.5rem 1.5rem !important;\n  font-weight: 700;\n  margin-inline-end: 4px;\n}\n\n.newtable .nav-link:not(.active) {\n  color: white;\n  transition: all .2s;\n}\n\n.newtable .nav-link:not(.active):hover {\n  color: black;\n  border: 1px solid white;\n  background: white;\n  transition: all .2s;\n}\n\n.newtable .nav-item > .dropdown > button {\n  margin: 4px;\n}\n\n.newtable .filters-row {\n  padding: 0px 0px 1rem;\n}\n\n.newtable .filters-row .dropdown,\n.audit-log-table-toolbar .dropdown  {\n  flex: 1;\n}\n\n.overflow-y-visble {\n  overflow-y: visible !important;\n}\n\n.btn-icon {\n  width: 26px;\n  height: 26px;\n  padding: 0 !important;\n  /* line-height: 1; */\n  line-height: 13px;\n  border-radius: 13px;\n  text-align: center;\n}\n\n.newtable .search--table,\n.audit-log-table-toolbar .search--table {\n  padding: 2px 0 2px 8px;\n  transition: all .2s;\n  border-bottom: solid 1px #f4f4f4;\n  color: white;\n  display: inline-flex;\n  height: var(--custom-height, 26px);\n  width: auto;\n  align-items: center;\n}\n\n.newtable .search--table:hover,\n.newtable .search--table:focus,\n.audit-log-table-toolbar .search--table:hover,\n.audit-log-table-toolbar .search--table:focus,\n.newtable .search--table:focus-within,\n.audit-log-table-toolbar .search--table:focus-within {\n  transition: all .2s;\n  opacity: 1;\n}\n\n.newtable .search--table input,\n.audit-log-table-toolbar .search--table input {\n  border: none;\n  display: flex;\n  background: transparent;\n  width: 100%;\n}\n\n.newtable .search--table i,\n.audit-log-table-toolbar .search--table i {\n  display: inline-flex;\n}\n\n.newtable .search--table input:focus,\n.newtable .search--table input:active,\n.audit-log-table-toolbar .search--table input:active,\n.audit-log-table-toolbar .search--table input:focus {\n  outline: none;\n}\n\n.nav-item + .search--table.ml-3 {\n  margin-inline-start: auto !important;\n}\n\n.hidden {\n  display: none !important;\n}\n\n.col-status-icon {\n  margin-inline-end: 4px;\n}\n\n.col-status-icon.zmdi-circle {\n  color: green\n}\n\n.col-status-icon.zmdi-circle-o {\n  color: #F4F4F4;\n}\n\n.json-data-view button {\n  margin: 0;\n  display: flex;\n}\n\n.json-data-view .json-data-view-array > li + li {\n  border-top: 1px solid #dee2e6\n}\n\n.modal-sizable {\n  max-width: 100% !important;\n\n  .modal-content {\n    > div {\n      display: flex;\n    }\n\n    .resizer {\n      cursor: col-resize;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      inset-inline-start: -12px;\n      -webkit-transition: all .3s ease;\n      -o-transition: all .3s ease;\n      transition: all .3s ease;\n      background: #efefef;\n      display: block;\n      padding: 0 3px;\n      line-height: 100vh;\n      z-index: 1234;\n      opacity: 0;\n    }\n\n    &:hover {\n      .resizer {\n        opacity: 1;\n        -webkit-transition: all .3s ease;\n        -o-transition: all .3s ease;\n        transition: all .3s ease;\n      }\n    }\n  }\n\n  &.modal-align-left {\n    .resizer {\n      inset-inline-start: auto;\n      inset-inline-end: -12px;\n    }\n  }\n}\n\ntable.json-data-view-object-item td:nth-child(2),\ntable.json-data-view-array td:nth-child(2) {\n  padding-inline-end: 0;\n}\n\ntable.json-data-view-object-item > tr:nth-child(1) > td,\ntable.json-data-view-array > tr:nth-child(1) > td {\n  border-top: none;\n}\n\n// Field History\n.item-fieldname-cell {\n  width: 25%;\n  vertical-align: top;\n}\n\n.history-icon {\n  color: #91adf0;\n  font-size: 14px;\n}\n\n.field-history-icon-container {\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n\n  &:last-child {\n    display: flex;\n    align-self: self-start;\n    padding: 10px;\n    border-radius: 4px;\n\n    &:hover {\n      background-color: #ebf1f6;\n    }\n  }\n}\n\n.field-history {\n  .db-audit-field-log-list-table {\n    .rt-table {\n      overflow-x: auto !important;\n    }\n  }\n\n  &-modal {\n    .modal-content > div > div {\n      min-width: initial !important;\n    }\n  }\n\n  &-info {\n    margin-bottom: 1.5rem;\n\n    .info-heading {\n      font-weight: 400;\n      color: #4B4B4B;\n    }\n\n    .info-value {\n      font-weight: 600;\n      color: #222222;\n    }\n\n    :where(th, td) + :where(th, td) {\n      padding-inline-start: 16px;\n    }\n  }\n}\n\n.block-history {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.history-entries {\n  display: flex;\n  overflow-x: auto;\n  padding-bottom: 16px;\n}\n\n.history-item {\n  min-width: 150px;\n  border: solid 1px #f2f2f2;\n\n  &.selected {\n    background-color: #ebf1f6;\n    transition-duration: 0.15s;\n  }\n\n  &-date {\n    padding: 6px 10px;\n    font-weight: 600;\n  }\n\n  &-field {\n    .pointer {\n      align-items: center;\n      justify-content: space-between;\n\n      &:hover {\n        background-color: #f2f2f2;\n      }\n    }\n\n    &.selected {\n      .pointer {\n        background-color: #d2dfeb;\n      }\n    }\n  }\n\n  .item-field-name {\n    display: flex;\n    padding: 6px 10px;\n    gap: 10px;\n  }\n}\n\n// End Field history\n\n/*table.json-data-view-object-item td[colspan='2'] > table > tbody > tr > td,\ntable.json-data-view-array td[colspan='2'] > table > tbody > tr > td {\n    border: none;\n}*/\n\ntable.json-data-view-object-item td > .table,\ntable.json-data-view-array td > .table {\n  background-color: transparent;\n}\n\n.json-data-view-array > tr:nth-child(odd) {\n  background-color: #f4f4f4;\n}\n\n.json-data-view-array > tr:nth-child(even) {\n  background-color: #efefef;\n}\n\n.import-json-button, .export-json-button {\n  margin: 0 !important;\n  position: absolute !important;\n  top: 0 !important;\n  inset-inline-end: 0 !important;\n  display: inline-block !important;\n  font-weight: 400 !important;\n  text-align: center !important;\n  white-space: nowrap !important;\n  vertical-align: middle !important;\n  user-select: none !important;\n  padding: .375rem .75rem !important;\n  font-size: 13px !important;\n  line-height: 1.2 !important;\n  border-radius: .25rem !important;\n  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !important;\n  color: #99BBCD !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  border-color: #99BBCD !important;\n  text-shadow: none !important;\n  height: auto !important;\n}\n\n.import-json-button:hover,\n.import-json-button:focus,\n.import-json-button:active,\n.export-json-button:hover,\n.export-json-button:focus,\n.export-json-button:active {\n  color: #fff !important;\n  background-color: #99BBCD !important;\n  border-color: #99BBCD !important;\n}\n\n.export-json-button {\n  inset-inline-end: 140px !important;\n}\n\n.json-schema-react-editor .close {\n  float: none;\n  opacity: 1;\n  font-size: inherit;\n}\n\n@media screen and (min-width: 1280px) {\n  .json-schema-react-editor .col-item-name {\n    width: 35% !important;\n  }\n  .json-schema-react-editor .col-item-desc {\n    width: 10% !important;\n  }\n}\n\n\n.Resizer {\n  background: #000;\n  opacity: .2;\n  z-index: 1;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -moz-background-clip: padding;\n  -webkit-background-clip: padding;\n  background-clip: padding-box;\n}\n\n.Resizer:hover {\n  -webkit-transition: all 2s ease;\n  transition: all 2s ease;\n}\n\n.Resizer.horizontal {\n  height: 11px;\n  margin: -5px 0;\n  border-top: 5px solid rgba(255, 255, 255, 0);\n  border-bottom: 5px solid rgba(255, 255, 255, 0);\n  cursor: row-resize;\n  width: 100%;\n}\n\n.Resizer.horizontal:hover {\n  border-top: 5px solid rgba(0, 0, 0, 0.5);\n  border-bottom: 5px solid rgba(0, 0, 0, 0.5);\n}\n\n.Resizer.vertical {\n  width: 11px;\n  margin: 0 -5px;\n  border-inline-start: 5px solid rgba(255, 255, 255, 0);\n  border-inline-end: 5px solid rgba(255, 255, 255, 0);\n  cursor: col-resize;\n}\n\n.Resizer.vertical:hover {\n  border-inline-start: 5px solid rgba(0, 0, 0, 0.5);\n  border-inline-end: 5px solid rgba(0, 0, 0, 0.5);\n}\n\n.Resizer.disabled {\n  cursor: not-allowed;\n}\n\n.Resizer.disabled:hover {\n  border-color: transparent;\n}\n\n\n.SplitPane {\n  position: relative !important;\n}\n\n/* Filters row */\n.filters-rows .filter-row .btn-add-row {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.filters-rows .filter-row:last-child .btn-add-row {\n  opacity: 1;\n  pointer-events: initial;\n}\n\n.filters-rows .filter-row:first-child [name=\"gate\"] {\n  display: none;\n}\n\n.filters-row .filter-separator {\n  width: 1px;\n  height: 25px;\n  background: #ccc;\n}\n\n.filters-row .btn.btn-default,\n.filters-row .btn.btn-outline-default:hover {\n  color: black;\n  background-color: #F4F4F4;\n}\n\n.filters-row .btn.btn-default.btn-secondary:not(:disabled):not(.disabled):active,\n.filters-row .btn.btn-default.btn-secondary:not(:disabled):not(.disabled).active,\n.show > .btn.btn-default.btn-secondary.dropdown-toggle\n.filters-row .btn.btn-default:hover,\n.filters-row .btn.btn-default:active,\n.filters-row .btn.btn-default:focus {\n  outline: none;\n  color: black;\n  background-color: #ccc;\n}\n\n.upload-label {\n  display: block;\n}\n\n.db-name input#catalog_name,\n.db-name input#name {\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.db-image img {\n  max-height: 50px;\n}\n\nspan.db-name,\nspan.db-group-name {\n  font-size: 20px;\n  vertical-align: middle;\n  font-weight: 500;\n}\n\nspan.db-code {\n  vertical-align: middle;\n  line-height: 21px;\n  font-size: 14px !important;\n}\n\n.db-image + .db-name,\n.db-image + .db-group-name {\n  margin-inline-start: 15px;\n}\n\n.row-extra-props {\n  background: #f4f4f4;\n}\n\n.sidebar-header .db-image + .db-name {\n  display: none;\n}\n\n.schema-json-editor-content {\n  position: relative;\n}\n\n.ant-modal-mask {\n  z-index: 1050;\n}\n\n.ant-modal-wrap {\n  z-index: 1052;\n}\n\n.ant-modal-header {\n  text-align: start;\n}\n\n.ant-modal-close {\n  right: initial;\n  inset-inline-end: 0;\n}\n\n.ant-modal-footer {\n  text-align: end;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}\n\n.table-scrollbar {\n  width: 100%;\n  overflow: hidden;\n  overflow-x: auto;\n  min-height: 9px;\n}\n\n.table-scrollbar > div {\n  height: 1px;\n}\n\n.version-label-separator {\n  display: inline-flex;\n  width: 1px;\n  margin-inline: 4px;\n  height: 14px;\n  background-color: #1b255f;\n  align-self: center;\n}\n\n.version-dropdown {\n  justify-content: center !important;\n}\n\n.version-selector .btn {\n  text-transform: none !important;\n}\n\n.popover-body.action-permission-items {\n  overflow-y: auto;\n  max-height: 30vh;\n}\n\n.json-data-view-object-item .rdtPicker {\n  position: initial !important;\n}\n\n.docx-viewer-container {\n  overflow: auto;\n}\n\n.select-box {\n  [class*=\"-option\"] {\n    white-space: break-spaces;\n    line-break: anywhere;\n    line-height: 1.3;\n  }\n}\n\n// TODO: Remove reports?\n/* Reports */\n.filters-rows-action .addReport {\n  display: none !important;\n}\n\n.data-filter-table + .filters-rows-action .addReport {\n  display: inline-block !important;\n}\n\n.data-filter-table {\n  .react-autosuggest__container,\n  select,\n  .select-box > div {\n    min-height: 32px;\n  }\n\n  .select-box > div {\n    border-radius: 6px;\n\n    > div {\n      &:first-child {\n        padding: 0 8px;\n\n        & + div {\n          div {\n            padding: 4px;\n          }\n        }\n      }\n    }\n  }\n\n  td.filter-value-column {\n    .multi-select {\n      min-width: 150px;\n\n      .mustache {\n        background-color: #C0D6A0;\n\n        + div {\n          background-color: #C0D6A0;\n        }\n      }\n    }\n  }\n}\n\n.add-report-form-container {\n  width: 500px;\n}\n\n.flex-one {\n  flex: 1;\n}\n\n.form-control.rbt-input-multi {\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n}\n\n.report-applied-filters {\n  font-size: 120%;\n}\n\n.report-applied-filters .filter-field,\n.report-applied-filters .filter-value {\n  font-weight: 800;\n  color: #125375;\n}\n\n.report-applied-filters .filter-logic {\n  font-weight: 600;\n  padding: 0 4px;\n}\n\n.report-detail {\n  display: grid;\n  height: 100%;\n  grid-template-rows: min-content auto 50px;\n  max-width: 100%;\n  overflow-x: hidden;\n  grid-gap: 10px;\n\n  .filters-block {\n    margin-top: 1rem;\n    text-align: start;\n  }\n\n  .report-general-info:empty + .filters-block {\n    margin-top: 0;\n  }\n}\n\n.report-table {\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.report-table .table-scrollbar {\n  background-color: rgba(0, 0, 0, 0.02);\n  height: 9px;\n}\n\n.report-table .table-scrollbar:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n\n.ReactTable.mainReportTable .pagination-bottom .-pagination {\n  box-shadow: none;\n  border-top: none;\n  display: grid;\n  grid-template-columns: 40px auto 40px;\n  justify-content: center;\n}\n\n.ReactTable.mainReportTable .pagination-bottom .-pagination .-pageSizeOptions,\n.ReactTable.mainReportTable .pagination-bottom .-pagination .-pageInfo {\n  margin: 0px 10px;\n}\n\n.ReactTable.mainReportTable {\n  max-height: calc(100% - 10px);\n}\n\n.report-applied-filters-edit .data-filter-table {\n  margin: 0;\n  width: 100%;\n}\n\n.report-applied-filters-edit .data-filter-table .form-control {\n  max-width: 100%;\n  width: 100%;\n  min-width: 100px;\n}\n\n.report-applied-filters-edit .data-filter-table select[name=logic].form-control,\n.report-applied-filters-edit .data-filter-table select[name=gate].form-control {\n  min-width: 60px;\n}\n\n.report-applied-filters-edit .data-filter-table tr:not(:last-of-type) td.filter-value-column input {\n  width: 100%;\n}\n\n.report-applied-filters-edit .data-filter-table tr td:last-of-type {\n  width: 60px;\n  text-align: left !important;\n}\n\n.rtf-viewer-container {\n  padding: 5px;\n  overflow-y: auto;\n}\n\n.odf-viewer-container {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.odf-viewer-container .caret {\n  opacity: 0 !important;\n}\n\n.notification-container .notification-message .message {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  hyphens: auto;\n}\n\n.notification-container:not(.notification-container-empty) {\n  bottom: 0;\n  justify-content: flex-end;\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 24px;\n  max-height: 100%;\n  gap: 10px;\n\n  > div:only-child:not(.notification) {\n    display: contents;\n  }\n\n  .notification {\n    margin: 0;\n    width: fit-content;\n    max-width: 320px;\n    padding-inline-start: 3rem;\n    padding: 0px;\n    padding-inline-start: 56px;\n    background-color: rgba(var(--toastr-color), 0.85);\n    transition-duration: 0.15s;\n    border: solid 1px rgb(var(--toastr-color));\n    border-radius: 6px;\n    --shadow-color-rgb: var(--toastr-color);\n    --shadow-opacity: .5;\n    box-shadow: 0px 6px 20px rgba(var(--toastr-color), 0.5);\n    -webkit-backdrop-filter: blur(3px);\n    backdrop-filter: blur(3px);\n    min-height: 56px;\n    overflow: hidden;\n\n    &::before {\n      -moz-osx-font-smoothing: grayscale;\n      -webkit-font-smoothing: antialiased;\n      display: grid;\n      font-style: normal;\n      place-content: center;\n      font-variant: normal;\n      text-rendering: auto;\n      line-height: 1;\n      font-family: \"Font Awesome 6 Pro\";\n      font-weight: 700;\n      position: absolute;\n      inset-inline-start: 15px;\n      top: 50%;\n      font-size: 20px;\n    }\n\n    &.notification-success {\n      --toastr-color: 56, 159, 143;\n\n      &:hover {\n        --toastr-color: 26, 137, 120;\n      }\n\n      &::before {\n        content: \"\\F058\";\n      }\n    }\n\n    &.notification-error {\n      --toastr-color: 247, 95, 95;\n\n      &:hover {\n        --toastr-color: 244, 47, 47;\n      }\n\n      &::before {\n        content: \"\\F057\";\n      }\n    }\n\n    &.notification-warning {\n      --toastr-color: 255, 160, 118;\n\n      &:hover {\n        --toastr-color: 255, 124, 66;\n      }\n\n      &::before {\n        content: \"\\F071\";\n      }\n    }\n\n    &.notification-info {\n      --toastr-color: 76, 170, 229;\n\n      &:hover {\n        --toastr-color: 6, 156, 249;\n      }\n\n      &::before {\n        content: \"\\F06A\";\n      }\n    }\n\n    .notification-message {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n      align-items: flex-start;\n      justify-content: center;\n      padding-inline: 20px;\n      padding-block: 10px;\n      background: white;\n      color: rgb(var(--toastr-color));\n    }\n  }\n}\n\n.notification-container-empty {\n  display: none;\n}\n\n.rt-table .rdtPicker {\n  position: fixed;\n}\n\n.diff-value-change {\n  display: flex;\n  flex-direction: row;\n}\n\n.advanced-management-system-list {\n  margin-bottom: 0 !important;\n}\n\n.advanced-management-system-list .data-field-permission-cell {\n  text-align: center;\n}\n\n.advanced-management-system-list .data-field-permission-header {\n  text-align: center;\n}\n\n.advanced-management-system-list .data-field-permission-header p {\n  margin-bottom: 0;\n  font-weight: lighter;\n}\n\n.advanced-management-system-list .data-field-permission-header p:first-child {\n  margin-bottom: 0;\n  font-weight: bold;\n}\n\n.advanced-management-system-list td, .advanced-management-system-list th {\n  background: white;\n  border-inline-start: solid 1px #d5d5d5;\n  border-inline-end: solid 1px #d5d5d5;\n}\n\n.advanced-management-system-list th:first-child, .advanced-management-system-list td:first-child {\n  position: -webkit-sticky;\n  position: sticky;\n  inset-inline-start: 0;\n  z-index: 1;\n  border-inline-start: none;\n  border-inline-end: none;\n}\n\n.x-scroll-content {\n  overflow-x: hidden;\n}\n\n.table-caption {\n  text-align: center;\n  background: white;\n  padding-bottom: 10px;\n  padding-top: 5px;\n}\n\n[data-rbd-droppable-id] {\n  min-height: 20px;\n}\n\n.data-grid-list-table {\n  .rt-table {\n    max-height: 71vh;\n  }\n}\n\n.data-list-table {\n  .rt-table {\n    max-height: 65vh;\n  }\n}\n\n.react-table {\n  position: relative;\n  display: block;\n\n  .-loading {\n    display: block;\n    position: absolute;\n    inset-inline-start: 0;\n    inset-inline-end: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.8);\n    transition: all 0.3s ease;\n    opacity: 1;\n    z-index: 4;\n    pointer-events: all;\n\n    .-loading-inner {\n      height: 100%;\n    }\n  }\n\n  .rt-table {\n    border-spacing: 0;\n    overflow-x: hidden !important;\n    overflow-y: auto;\n    /*border-top: solid 1px #ccc !important;*/\n\n    .rt-thead {\n      top: 0;\n      position: sticky;\n      z-index: 2;\n    }\n\n    .rt-tbody {\n      z-index: 1;\n    }\n\n    .rt-tfoot {\n      bottom: 0;\n      position: sticky;\n      z-index: 2;\n    }\n\n    .tr {\n      :last-child {\n        .td {\n          border-bottom: 0;\n        }\n      }\n    }\n\n    .th,\n    .td {\n      margin: 0;\n      background-color: #fff;\n      position: relative;\n\n      :last-child:not(button, .system-input-container) {\n        border-inline-end: 0;\n      }\n\n      .resizer {\n        --color-a: #f4f4f4;\n        --color-b: #e5e7eb;\n        display: inline-block;\n        background: transparent;\n        width: 6px;\n        height: 100%;\n        position: absolute;\n        inset-inline-end: 0px;\n        inset-inline-start: initial;\n        top: 0;\n        z-index: 1;\n        touch-action: none;\n        background-image: linear-gradient(90deg, var(--color-a) 25%, var(--color-b) 25%, var(--color-b) 50%, var(--color-a) 50%, var(--color-a) 75%, var(--color-b) 75%, var(--color-b) 100%);\n        background-size: 8px 8px;\n        opacity: 0;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n      &:hover {\n        .resizer {\n          opacity: 0.6;\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n      }\n    }\n\n    [data-sticky-td] {\n      position: sticky;\n    }\n\n    [data-sticky-last-left-td] {\n      box-shadow: 2px 0px 3px #ccc;\n    }\n\n    [data-sticky-first-right-td] {\n      box-shadow: -2px 0px 3px #ccc;\n    }\n\n    &.sticky {\n      overflow: scroll;\n    }\n\n  }\n}\n\n.pagination {\n  padding: 0.5rem;\n}\n\n.log-list-table, .db-audit-log-list-table, .translations-table {\n  .rt-table {\n    max-height: 66vh;\n  }\n}\n\n.service-list-table {\n  .rt-table {\n    max-height: 65vh;\n  }\n}\n\n.data-list-report-table {\n  .rt-table {\n    max-height: 58vh;\n  }\n}\n\n.translations-table {\n  .rt-table {\n    .rt-thead > div {\n      background: #f4f4f4;\n    }\n  }\n\n  .message-content {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.table-scroll-horizontal > div.rt-table {\n  overflow-x: auto !important;\n}\n\n.user-rights-management {\n  .permissions-part {\n    .permissions-table > .filters-columns {\n      position: sticky;\n      top: 0;\n      z-index: 10;\n    }\n  }\n}\n\n.json-data-view {\n  .field-type-array .json-data-view-array > tbody > tr:not(:first-child) {\n    border-top: 1px solid #dee2e6;\n  }\n\n  .field-type-object + .field-type-array {\n    border-top: 1px solid #dee2e6;\n  }\n}\n\n\n.translations-table {\n  .translation-cell-buttons {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n    padding-top: 10px;\n  }\n}\n\n.data-list-table, .data-grid-list-table {\n  .editgrid-cell {\n    button {\n      margin-inline-end: 0;\n      margin-bottom: 0;\n      margin-top: 0;\n    }\n  }\n}\n\n.app-footer {\n  position: fixed;\n  bottom: 0;\n  z-index: 9;\n  inset-inline: 0;\n}\n\n.data-view-data-list-table {\n  .rt-table {\n    max-height: 70vh;\n\n    .btn-link {\n      padding: 0;\n      margin: 0;\n\n      > i {\n        padding-inline-end: 5px;\n      }\n    }\n  }\n}\n\n.data-view-list-table {\n  .rt-table {\n    max-height: 70vh;\n  }\n}\n\n.app-container.app-iframe {\n  .app-wrapper {\n    padding: 0;\n\n    .data-view-list-container {\n      height: 100vh;\n\n      & > div {\n        .nav {\n          border-top-left-radius: 0 !important;\n          border-top-right-radius: 0 !important;\n        }\n      }\n    }\n\n    .newtable {\n      padding-top: 0;\n    }\n  }\n  .nav-pages {\n    li.nav-item:first-child {\n      a.nav-link {\n        padding-inline-start: 0px;\n      }\n    }\n  }\n  .pagination {\n    container-type: inline-size;\n    container-name: iframe-pagination;\n    min-width: 652px;\n\n    // .page-info {\n    //   margin-inline-end: 3rem;\n    // }\n  }\n}\n\n.data-view-embed-code {\n  height: 100%;\n  \n  iframe {\n    width: 100%;\n    height: 100%;\n    background: #ffffff;\n    border-radius: 6px;\n    padding: 6px 16px 2px;\n    border: solid 1px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.data-view-filter-dropdown {\n  z-index: 12;\n}\n\n.data-view-list-container {\n  display: flex;\n  flex-direction: column;\n  height: 80vh;\n\n  .filters-row {\n    background-color: transparent;\n\n    .columns-toggler {\n      margin-inline-start: 6px;\n    }\n\n    .print-view {\n      border-radius: 6px;\n      padding: 0 0.6rem;\n      font-weight: 500;\n      font-size: 12px;\n      color: #1b255f !important;\n      height: 32px;\n      transition-duration: 0.3s;\n\n      &:hover {\n        background-color: #EAEDF2;\n      }\n    }\n  }\n\n  ul {\n    &.nav.nav-tabs {\n      padding: 0;\n\n      li {\n        &.nav-item {\n          box-shadow: none !important;\n\n          a {\n            &.nav-link {\n              text-transform: uppercase;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .data-view-list-table-container {\n    display: flex;\n    flex-grow: 1;\n    flex-wrap: wrap;\n    height: 0;\n\n    > .tab-content {\n      height: 100%;\n      width: 100%;\n      box-shadow: none;\n\n      > .tab-pane.active {\n        height: 100%;\n\n        > div.react-table {\n          width: 100%;\n\n          &.data-view-data-list-table {\n            .rt-table {\n              max-height: calc(100vh - 240px);\n\n              .rt-thead {\n                .tr {\n                  &:first-child {\n                    &:not(:last-child) {\n                      .th {\n                        &[role=\"columnheader\"] {\n                          border-inline-end: solid 1px #A3ADC5;\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n\n              .rt-tfoot {\n                bottom: -1px;\n\n                .tr {\n                  .td {\n                    box-shadow: none;\n                    background-color: #DAE4EE;\n                    color: #1b255f;\n                    align-items: center;\n                    padding-inline-start: 15px !important;\n                    padding-inline-end: 15px !important;\n\n                    &.type-number {\n                      text-align: right;\n                    }\n\n                    &[data-sticky-last-left-td=\"true\"] {\n                      //border-inline-end: solid 1px color(\"celia\", \"sharp-border\");\n                    }\n\n                    &[data-sticky-first-right-td=\"true\"] {\n                      //border-inline-start: solid 1px color(\"celia\", \"sharp-border\");\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .pagination {\n            span {\n              white-space: nowrap;\n            }\n          }\n        }\n      }\n    }\n\n    &.data-view-hidden-pagination {\n      .tab-content {\n\n        > .tab-pane.active {\n\n          > div.react-table {\n\n            & > .rt-table {\n              max-height: 100%;\n            }\n\n          }\n        }\n      }\n    }\n  }\n\n  &.tableoptions--closed {\n    .data-view-list-table-container {\n      > .tab-content {\n        > .tab-pane.active {\n          > div.react-table {\n            &.data-view-data-list-table {\n              .rt-table {\n                max-height: calc(100vh - 236px);\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .rt-tfoot {\n    margin-top: 63px;\n  }\n  .react-table .rt-table .rt-tbody .tr .td:is(.type-array_of_file, .type-file) {\n    &:has(button) {\n      padding-inline: 6px;\n    }\n  }\n}\n\n.drop-drag-fields-view {\n  > .Pane:first-child {\n    > div {\n      > .react-table {\n        > .rt-table {\n          overflow-y: auto;\n        }\n      }\n    }\n  }\n\n  > .Pane:last-child {\n    > div {\n      height: 100%;\n\n      > .react-table {\n        height: 100%;\n\n        > .rt-table {\n          height: 100%;\n          overflow-y: auto;\n          display: flex;\n          flex-direction: column;\n\n          .rt-tbody {\n            flex: auto;\n            min-height: initial !important;\n            display: flex;\n            flex-direction: column;\n\n            > div {\n              flex: 1;\n              display: flex;\n              flex-direction: column;\n\n              .tr {\n                flex: initial !important;\n              }\n\n              :is(.drop-placeholder, .droppable-placeholder) {\n                flex: 1;\n                display: grid;\n                place-items: center;\n                min-height: 150px;\n              }\n            }\n          }\n\n          &.empty-rows {\n            height: calc(100% - 36px);\n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            user-select: none;\n\n            > .rt-tbody {\n              height: calc(100% - 36px);\n\n              > div {\n                display: table;\n                width: 100%;\n                text-align: center;\n                height: 100%;\n                border-bottom: solid 2px #ccc !important;\n                border-inline-start: solid 2px #ccc !important;\n                border-inline-end: solid 2px #ccc !important;\n                transition: 0.3s;\n                font-weight: bold;\n\n                > :where(.drop-placeholder, .droppable-placeholder) {\n                  display: table-cell;\n                  vertical-align: middle;\n                }\n\n                &.dragging-over {\n                  background: #63a386;\n                  color: #fff;\n                  border-color: #63a386;\n                }\n              }\n            }\n          }\n\n          &:not(.empty-rows) {\n            > .rt-tbody {\n              > div {\n                transition: 0.3s;\n\n                > :where(.drop-placeholder, .droppable-placeholder) {\n                  transition: 0.3s;\n                  text-align: center;\n                  border: dashed 2px #ccc !important;\n                  -webkit-user-select: none;\n                  -moz-user-select: none;\n                  -ms-user-select: none;\n                  user-select: none;\n                }\n\n                &.dragging-over {\n                  > .droppable-placeholder {\n                    background: #63a386;\n                    color: #fff;\n                    border-color: #63a386;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  > .Pane {\n    max-height: calc(100vh - 180px);\n    overflow-y: auto;\n  }\n}\n.app-header:has(.appbar--collapsed) + .app-main-content-wrapper {\n  .drop-drag-fields-view > .Pane {\n    max-height: calc(100vh - 120px);\n  }\n}\n\n.search-field {\n  margin-bottom: 6px;\n  cursor: pointer;\n  border: solid 1px rgba(74, 98, 136, 0.2);\n  border-radius: 6px;\n\n  input {\n    font-weight: 400;\n    color: rgba(27, 37, 95, 1);\n    border: none;\n    padding: 0;\n    height: 24px;\n    font-size: 14px;\n    line-height: 2;\n\n    &:focus-visible {\n      outline: none;\n    }\n  }\n\n  &:hover,\n  &:focus-within {\n    border-color: #80bdff;\n  }\n}\n\n.flex-grow-1 {\n  flex-grow: 1;\n}\n\n.permission-row {\n  .permission-status {\n    display: flex;\n    flex-direction: column;\n\n    > div {\n      flex: 1;\n      align-items: center;\n      display: flex;\n      height: 40px;\n    }\n  }\n}\n\n.btn.file-link {\n  text-transform: inherit !important;\n}\n\n.react-table {\n  .td {\n    > button {\n      padding: 0;\n      margin: 0;\n    }\n  }\n}\n\n.react-table.db-audit-log-list-table .rt-table .rt-tbody .tr .td {\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  white-space: nowrap;\n}\n\nbutton.db-records {\n  display: inline-block !important;\n\n  & + span {\n    margin-inline-start: 5px;\n  }\n}\n\n.select-another-db-block {\n  > h2 {\n    margin-bottom: 5px !important;\n  }\n\n  div.db-link {\n    display: block;\n\n    > a {\n      color: #333;\n\n      &:hover {\n        text-decoration: none !important;\n        color: #99BBCD;\n      }\n\n      span.db-code {\n        font-weight: 700;\n        color: #777777;\n        text-transform: uppercase;\n        font-size: 82%;\n        margin-inline-start: 5px;\n      }\n    }\n  }\n}\n\n.diagram-container {\n  height: 100%;\n  display: flex;\n  background: #F1F2F4;\n\n  > * {\n    height: 100%;\n    min-height: 100%;\n    width: 100%;\n\n    > * {\n      overflow: visible !important;\n\n      .node {\n        //>div {\n        //  color: black !important;\n        //  background: #f6f6f6 !important;\n        //  > div:first-child {\n        //    background: #316896 !important;\n        //    color: white !important;\n        //  }\n        //}\n        z-index: 1;\n        &:hover {\n          z-index: 100;\n        }\n        div {\n          white-space: nowrap !important;\n          //.port {\n          //  > div {\n          //    background: none !important;\n          //  }\n          //}\n        }\n      }\n    }\n  }\n}\n\n.app-diagram-wrapper {\n  height: 100%;\n  position: relative;\n}\n\n.advanced-management-system-list {\n  td.auth-name {\n    padding: 3px 11px;\n    text-align: left;\n    font-style: italic;\n    color: #909090;\n  }\n}\n\n.user-management-table {\n  td.auth-name {\n    padding: 3px 11px;\n    text-align: left;\n    font-style: italic;\n    color: #909090;\n  }\n}\n\n.user-management-services {\n  .auth-name {\n    text-align: left;\n    font-style: italic;\n    color: #909090;\n  }\n\n  li.auth-name {\n    list-style-type: none;\n  }\n}\n\n.user-management-service-popover-body {\n  .auth-name {\n    text-align: left;\n    font-style: italic;\n    color: #909090;\n  }\n}\n\nspan {\n  > span.auth-name {\n    margin-inline-start: 3px;\n    text-align: left;\n    font-style: italic;\n    color: #909090;\n  }\n}\n\n.role-users-management-content {\n  .toggle-icon {\n    height: 30px;\n    align-items: center;\n    cursor: pointer;\n    font-size: 28px;\n    transition-duration: 0.2s;\n  }\n\n  tr > td:last-child {\n    padding-inline-start: 10px;\n  }\n\n  tr.auth-group {\n    > td:first-child {\n      text-align: left;\n      font-style: italic;\n      color: #909090;\n    }\n  }\n\n  tr.anonymous-user {\n    td:first-child {\n      font-weight: bold;\n    }\n  }\n}\n\n.newtable {\n  > .nav {\n    position: relative;\n\n    .db-options-buttons {\n      > .search--table {\n        position: absolute;\n        top: 3px;\n        inset-inline-end: 46px;\n        visibility: hidden;\n        width: 60%;\n        background-color: #f4f4f4;\n\n        &.search--opened {\n          visibility: visible;\n        }\n      }\n\n      .options-buttons {\n        white-space: nowrap;\n      }\n    }\n  }\n}\n\n.audit-log-detail-view {\n  table {\n    tr {\n      > td {\n        &:first-child {\n          white-space: nowrap;\n        }\n\n        &:last-child {\n          word-break: break-all;\n        }\n      }\n    }\n  }\n}\n\n.blockchain-icon {\n  width: 22px;\n  margin-inline-start: 5px;\n  margin-inline-end: 5px;\n}\n\n.blockchain-detail-popover {\n  .popover-header {\n    background-color: #f7f7f7;\n  }\n\n  .blockchain-algorithm {\n    font-style: italic;\n    color: #7a7a7a;\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 10;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n  }\n}\n\n.force-select {\n  -webkit-user-select: all; /* Chrome 49+ */\n  -moz-user-select: all; /* Firefox 43+ */\n  -ms-user-select: all; /* No support yet */\n  user-select: all; /* Likely future */\n}\n\n.header-vertical-align-bottom {\n  display: flex;\n  flex-direction: column-reverse;\n  height: 100%;\n}\n\n/* Celia design */\n\n.service-swagger-ui {\n  & > .swagger-ui {\n    :where(.highlight-code, .opblock-section-header) {\n      text-align: start;\n    }\n\n    .opblock-title {\n      display: flex;\n    }\n\n    > div {\n      display: none;\n\n      &:last-child {\n        display: block;\n      }\n\n      & > .wrapper {\n        padding: 0;\n\n        .opblock-summary {\n          button.opblock-summary-control {\n            pointer-events: none;\n\n            svg.arrow {\n              display: none;\n            }\n          }\n\n          button.authorization__btn {\n            display: none;\n          }\n        }\n\n        & + .wrapper {\n          display: none;\n        }\n\n        .opblock-tag-section {\n          & > h3.opblock-tag {\n            display: none;\n          }\n        }\n      }\n    }\n\n    .information-container {\n      display: none;\n    }\n\n    .scheme-container {\n      display: none;\n    }\n  }\n}\n\n.report-column-selection {\n  .dropdown {\n    width: 100%;\n\n    & > button {\n      width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n\n      .selected-field {\n        &::after {\n          content: \", \";\n        }\n\n        &:last-child::after {\n          content: \"\";\n        }\n\n        + .selected-field {\n          margin-inline-start: 3px;\n\n        }\n      }\n    }\n  }\n}\n\n.monitor-tooltip {\n  .tooltip-inner {\n    max-width: none;\n  }\n}\n\n.user-username {\n  font-size: 10px;\n}\n\n.data-list-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 135px);\n  gap: 20px;\n\n  .data-list-table-container {\n    display: flex;\n    flex-grow: 1;\n    flex-wrap: wrap;\n    height: 0;\n\n    > .SplitPane {\n      .Pane {\n        > .tab-pane {\n          height: 100%;\n\n          > .react-table {\n            height: 100%;\n\n            > .rt-table {\n              max-height: calc(100% - 36px - 25px);\n              overflow-x: auto !important;\n\n            }\n          }\n        }\n      }\n    }\n    > .tab-content {\n      width: 100%;\n      height: 100%;\n      box-shadow: none;\n\n      > .tab-pane {\n        width: 100%;\n        height: 100%;\n\n        > .react-table {\n          width: 100%;\n          height: 100%;\n\n          > .rt-table {\n            max-height: calc(100% - 36px - 25px);\n            overflow-x: auto !important;\n          }\n\n        }\n      }\n    }\n    &.main-data-split-container {\n      .Pane2 {\n        min-width: 200px;\n\n        > div {\n          height: 100%;\n        }\n      }\n    }\n  }\n}\n\n.document-image-view {\n  text-align: center;\n}\n\n.document-viewer-pagination {\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-columns: repeat(3, 1fr);\n  padding-bottom: 1rem;\n  align-items: center;\n\n  .previous {\n    text-align: start;\n  }\n\n  .next {\n    text-align: end;\n  }\n\n  .current-page {\n    text-align: center;\n  }\n}\n\n.trash-button {\n  display: inline-block;\n\n  .button {\n    display: block;\n  }\n}\n\n.form-control-color {\n  width: 27px;\n}\n\n.entity-relationship-node {\n  position: relative;\n  font-family: Arial;\n  min-width: 150px;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.05);\n  font-size: 22px;\n  --editgrid-node-color: #316896;\n  --left-port-color: rgba(0, 0, 0, 0.9);\n  --right-port-color: rgba(0, 0, 0, 0.3);\n  --level: 1;\n  --roundness: 0.65rem;\n  --port-hover-color: #f4f4f4;\n  border-radius: var(--roundness);\n  transition: all .2s;\n\n  .node-description {\n    display: none;\n    padding: 0 0 16px;\n\n    .fa-database {\n      font-size: 80px;\n    }\n  }\n  &.summarised {\n    box-shadow: none;\n    background-color: transparent;\n    transition: all .2s;\n\n    .node-description {\n      display: initial;\n    }\n    .expand-collapse-all {\n      display: none;\n    }\n  }\n\n  .node-header {\n    flex-grow: 1;\n    padding: 10px 20px;\n    margin-bottom: 0;\n    color: white;\n    font-weight: bold;\n    cursor: pointer;\n    border-radius: var(--roundness) var(--roundness) 0 0;\n    text-align: start;\n\n    .options-icon {\n      opacity: 0;\n      transition: all .2s;\n      color: white;\n    }\n\n    .toggle-icon {\n      color: white;\n    }\n\n\n    &.summarised {\n      z-index: 5;\n      border-radius: var(--roundness);\n\n      .expand-collapse-all {\n        display: none;\n      }\n\n      + div {\n        :is(.node-port, .port-children) {\n          z-index: 4;\n          position: absolute;\n          top: 0;\n          visibility: hidden;\n          overflow: hidden;\n          margin-top: 0;\n        }\n\n        .port-children {\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  &:hover {\n    z-index: 5;\n\n    &::before {\n      z-index: 1;\n      content: \" \";\n      top: -2px;\n      left: -100vw;\n      position: absolute;\n      width: 200vw;\n      height: 2px;\n      background: -moz-linear-gradient(left, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, .5) 50%, rgba(49, 104, 150, 0) 75%); /* FF3.6-15 */\n      background: -webkit-linear-gradient(left, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, .5) 50%, rgba(49, 104, 150, 0) 75%); /* Chrome10-25,Safari5.1-6 */\n      background: linear-gradient(to right, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, .5) 50%, rgba(49, 104, 150, 0) 75%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00316896', endColorstr='#00316896', GradientType=1); /* IE6-9 */\n    }\n\n    &::after {\n      z-index: 2;\n      content: \" \";\n      top: -100vw;\n      left: -2px;\n      position: absolute;\n      height: 200vw;\n      width: 2px;\n      background: -moz-linear-gradient(top, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, .5) 50%, rgba(49, 104, 150, 0) 75%); /* FF3.6-15 */\n      background: -webkit-linear-gradient(top, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, .5) 50%, rgba(49, 104, 150, 0) 75%); /* Chrome10-25,Safari5.1-6 */\n      background: linear-gradient(to bottom, rgba(49, 104, 150, 0) 25%, rgba(49, 104, 150, .5) 50%, rgba(49, 104, 150, 0) 75%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00316896', endColorstr='#00316896', GradientType=0); /* IE6-9 */\n    }\n\n    .node-header {\n      z-index: 4;\n\n      & + div {\n        z-index: 3;\n      }\n    }\n\n    .options-icon {\n      opacity: 1;\n      transition: all .2s;\n    }\n  }\n\n  .node-description {\n    flex-grow: 1;\n    padding: 10px 20px;\n    position: relative;\n  }\n\n  .node-port {\n    flex-grow: 1;\n    padding: 10px 20px;\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    font-weight: 600;\n    width: 100%;\n\n    &.collapsible {\n      color: var(--left-port-color);\n      margin-top: 20px;\n      transition-duration: 0.1s;\n      transition-property: margin-top;\n\n      .left-port {\n        font-weight: 800;\n        color: inherit;\n        display: flex;\n        align-items: center;\n      }\n\n      &.field-type-array {\n        color: var(--editgrid-node-color);\n      }\n\n      &.collapsed {\n        margin-top: 0;\n        transition-duration: 0.1s;\n      }\n    }\n\n    .collapse-icon {\n      margin-inline-end: 10px;\n      cursor: pointer;\n      border-radius: 15px;\n      display: inline-flex;\n      line-height: 10px;\n      width: 20px;\n      height: 20px;\n      align-items: center;\n      justify-content: center;\n      background: #dee2e6;\n      font-size: 16px;\n    }\n\n    &.port-connected {\n      background: #deecf3;\n\n      .left-port {\n        .circle-porter {\n          inset-inline-start: -8px;\n        }\n      }\n\n      .right-port {\n        .circle-porter {\n          inset-inline-end: -8px;\n        }\n      }\n    }\n\n    .right-port {\n      margin-inline-start: 20px;\n      color: var(--right-port-color);\n      font-size: 18px;\n      align-self: flex-end;\n    }\n\n    .circle-porter {\n      position: absolute;\n      top: 23px;\n\n      .circle-port {\n        width: 16px;\n        height: 16px;\n        border-radius: 8px;\n        background: #ddd;\n        cursor: pointer;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n\n        &:hover {\n          background: #bbb;\n        }\n      }\n    }\n\n    &:hover {\n      background-color: var(--port-hover-color);\n    }\n\n    &:last-child {\n      border-radius: 0 0 var(--roundness) var(--roundness);\n    }\n  }\n\n  .port-children {\n    margin-bottom: 20px;\n    transition-duration: 0.1s;\n    transition-property: margin-bottom;\n\n    &.collapsed {\n      position: absolute;\n      margin-top: -53px;\n      inset-inline-end: 0;\n      inset-inline-start: 0;\n      visibility: hidden;\n\n      > .node-port {\n        position: absolute;\n        inset-inline-start: 0;\n        inset-inline-end: 0;\n      }\n    }\n\n    .node-port {\n      padding-inline-start: 29px;\n\n      .left-port {\n        margin-inline-start: calc(21px * var(--level));\n\n        .collapse-icon {\n          & + .left {\n            margin-inline-start: 0 !important;\n          }\n        }\n\n        .port + .left {\n          margin-inline-start: 9px;\n        }\n      }\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .node-header + div > .port-children > .node-port > .left-port > .left {\n    margin-inline-start: 0;\n  }\n}\n\n.diagram-tools-button {\n  position: absolute;\n  inset-inline-end: 19px;\n  bottom: 49px;\n  font-size: 30px;\n\n  + .diagram-tools-button {\n    bottom: 89px;\n  }\n}\n\n.modal-title {\n  span {\n    & + span.db-code {\n      margin-inline-start: 5px;\n    }\n  }\n}\n\n.x-road-icon {\n  width: 19px;\n}\n\n.react-autosuggest__input {\n  max-width: 240px;\n  height: 30px;\n  padding: 10px 20px;\n  font-family: Helvetica, sans-serif;\n  font-weight: 300;\n  font-size: 16px;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n}\n\n.react-autosuggest__input--focused {\n  outline: none;\n}\n\n.react-autosuggest__input--open {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.react-autosuggest__suggestions-container {\n  display: none;\n}\n\n.react-autosuggest__suggestions-container--open {\n  display: block;\n  position: absolute;\n  border: 1px solid #aaa;\n  background-color: #fff;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  z-index: 2;\n}\n\n.react-autosuggest__suggestions-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.react-autosuggest__suggestion {\n  cursor: pointer;\n  padding: 2px 5px;\n}\n\n.react-autosuggest__suggestion--highlighted {\n  background-color: #ddd;\n}\n\n.filter-value {\n  > .mustache {\n    background-color: #C0D6A0;\n    padding: 1px;\n    border-radius: 1px;\n  }\n}\n\n.data-filter-table {\n  td.filter-value-column {\n    .multi-select {\n      min-width: 150px;\n\n      .mustache {\n        background-color: #C0D6A0;\n\n        + div {\n          background-color: #C0D6A0;\n        }\n      }\n    }\n  }\n}\n\n.react-select__single-value {\n  .field-label + .field-label::before {\n    content: \".\";\n  }\n}\n\n.nested-path-label {\n  .field-label + .field-label::before {\n    content: \".\";\n  }\n}\n\n@container iframe-pagination (max-width: 652px) {\n  .app-container.app-iframe .pagination {\n    .page-info {\n      margin-inline-end: 1rem;\n    }\n    .ml-5 {\n      margin-inline-start: 1rem !important;\n    }\n  }\n}\n\n.resize-sensor {\n  direction: ltr !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
